function initEwCardEditor(root) {
  if (!root || root.dataset.ewEditorInitialized === 'true') return;
  root.dataset.ewEditorInitialized = 'true';

  root.innerHTML = `
    <style>
      .ew-editor-wrap {
        border: 1px solid #ddd;
        border-radius: 4px;
        padding: 16px;
      }

      .ew-editor-layout {
        display: block;
      }

      .ew-editor-toolbar {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
        align-items: center;
        margin-bottom: 6px;
      }

      .ew-editor-btn,
      .ew-editor-upload {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: auto;
        min-width: 150px;
        margin-bottom: 0;
      }

      .ew-editor-file {
        display: none;
      }

      .ew-editor-style-panel {
        width: min(100%, 520px);
        border: 1px solid #ddd;
        border-radius: 9px;
        background: #fff;
        overflow: hidden;
      }

      .ew-editor-style-panel summary {
        cursor: pointer;
        padding: 8px 10px;
        font-size: 13px;
        font-weight: 600;
        color: #1f1966;
        list-style: none;
      }

      .ew-editor-style-panel summary::-webkit-details-marker {
        display: none;
      }

      .ew-editor-style-panel summary::after {
        content: '+';
        float: right;
        font-weight: 700;
      }

      .ew-editor-style-panel[open] summary::after {
        content: '–';
      }

      .ew-editor-style-controls {
        display: grid;
        grid-template-columns: minmax(150px, 220px) 58px 42px auto;
        gap: 6px;
        align-items: center;
        width: auto;
        padding: 0 10px 10px;
      }

      .ew-editor-style-control {
        min-height: 34px;
        border: 1px solid #ddd;
        border-radius: 9px;
        background: #fff;
        color: #111;
        padding: 0 8px;
        font-size: 13px;
      }

      .ew-editor-style-control[type="color"] {
        width: 42px;
        padding: 3px;
      }



      .ew-editor-color-dropdown {
        position: relative;
        display: inline-flex;
      }

      .ew-editor-color-toggle {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 38px;
        height: 34px;
        border: 1px solid #ddd;
        border-radius: 999px;
        background: #fff;
        padding: 0;
        cursor: pointer;
      }

      .ew-editor-color-preview {
        width: 22px;
        height: 22px;
        border: 1px solid #999;
        border-radius: 999px;
        background: #000;
      }

      .ew-editor-color-menu {
        position: absolute;
        top: calc(100% + 8px);
        left: 50%;
        transform: translateX(-50%);
        z-index: 30;
        display: grid;
        gap: 8px;
        min-width: 190px;
        padding: 10px;
        border: 1px solid rgba(31, 25, 102, 0.18);
        border-radius: 16px;
        background: #fff;
        box-shadow: 0 8px 24px rgba(31, 25, 102, 0.14);
      }

      .ew-editor-color-menu[hidden] {
        display: none;
      }

      .ew-editor-color-menu .ew-editor-color-palette {
        display: flex;
        gap: 8px;
        align-items: center;
        justify-content: center;
      }

.ew-editor-color-menu .ew-editor-hex-input {
        grid-column: 1 / -1;
        width: 110px;
        justify-self: start;
        margin-top: 2px;
        text-align: left;
        padding: 0 12px;
        font-size: 13px;
      }

      .ew-editor-color-palette {
        display: inline-flex;
        gap: 4px;
        align-items: center;
      }

      .ew-editor-color-swatch {
        width: 28px;
        height: 28px;
        min-width: 28px;
        min-height: 28px;
        padding: 0;
        border: 1px solid #ddd;
        border-radius: 999px;
        background: #000;
        cursor: pointer;
      }

      .ew-editor-color-swatch.ew-light {
        border-color: #999;
      }

      .ew-editor-color-swatch.ew-active {
        outline: 2px solid #1f1966;
        outline-offset: 2px;
      }

      .ew-editor-hex-input {
        width: 86px;
        text-transform: uppercase;
        font-size: 12px;
      }

      .ew-editor-align-group {
        display: inline-flex;
        gap: 4px;
      }

      .ew-editor-align-btn {
        min-width: 34px;
        min-height: 34px;
        border: 1px solid #ddd;
        border-radius: 9px;
        background: #fff;
        color: #111;
        font-size: 14px;
      }

      .ew-editor-align-btn.ew-active {
        border-color: #1f1966;
        color: #1f1966;
        font-weight: 700;
      }

      .ew-editor-wrap button,
      .ew-editor-wrap .ew-editor-btn {
        border-radius: 9px;
      }

      .ew-editor-btn {
        min-height: 40px;
        padding: 0 14px;
        border: 1px solid #1f1966;
        border-radius: 9px;
        font-size: 16px;
        background: #fff;
        color: #1f1966;
        font-weight: 600;
      }

      .ew-editor-canvas-wrap {
        display: flex;
        flex-direction: column;
        gap: 12px;
        min-width: 0;
      }

      .ew-editor-canvas {
        position: relative;
        width: min(100%, 420px);
        max-width: 100%;
        aspect-ratio: 101 / 141;
        margin: 0 auto;
        background:
          linear-gradient(rgba(31, 25, 102, 0.35), rgba(31, 25, 102, 0.35)) 50% 0 / 1px 100% no-repeat,
          linear-gradient(rgba(31, 25, 102, 0.35), rgba(31, 25, 102, 0.35)) 0 51.06382979% / 100% 1px no-repeat,
          repeating-linear-gradient(90deg, rgba(31, 25, 102, 0.055) 0 1px, transparent 1px 24px),
          repeating-linear-gradient(0deg, rgba(31, 25, 102, 0.055) 0 1px, transparent 1px 24px),
          linear-gradient(rgba(31, 25, 102, 0.08), rgba(31, 25, 102, 0.08)) 0 0 / 100% 2.12765957% no-repeat,
          linear-gradient(rgba(31, 25, 102, 0.08), rgba(31, 25, 102, 0.08)) 0 0 / 2.97029703% 100% no-repeat,
          linear-gradient(rgba(31, 25, 102, 0.08), rgba(31, 25, 102, 0.08)) 100% 0 / 2.97029703% 100% no-repeat,
          #f8f5ef;
        border: 1px solid #ccc;
        border-radius: 4px;
        overflow: hidden;
      }

      .ew-editor-canvas::before {
        content: '';
        position: absolute;
        left: 2.97029703%;
        top: 2.12765957%;
        width: 94.05940594%;
        height: 97.87234043%;
        border: 1px dashed rgba(31, 25, 102, 0.7);
        box-sizing: border-box;
        pointer-events: none;
        z-index: 9999;
      }

      .ew-editor-canvas::after {
        content: 'Anschnitt 3 mm';
        position: absolute;
        top: 4px;
        left: 8px;
        font-size: 11px;
        line-height: 1.2;
        color: rgba(31, 25, 102, 0.75);
        pointer-events: none;
        z-index: 10000;
      }
      
      .ew-editor-canvas.ew-grid-hidden {
        background:
          linear-gradient(rgba(31, 25, 102, 0.08), rgba(31, 25, 102, 0.08)) 0 0 / 100% 2.12765957% no-repeat,
          linear-gradient(rgba(31, 25, 102, 0.08), rgba(31, 25, 102, 0.08)) 0 0 / 2.97029703% 100% no-repeat,
          linear-gradient(rgba(31, 25, 102, 0.08), rgba(31, 25, 102, 0.08)) 100% 0 / 2.97029703% 100% no-repeat,
          #f8f5ef;
      }

      .ew-editor-canvas.ew-grid-hidden::before,
      .ew-editor-canvas.ew-grid-hidden::after,
      .ew-editor-canvas.ew-export-mode::before,
      .ew-editor-canvas.ew-export-mode::after {
        display: none;
      }

      .ew-editor-delete-selection {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 34px;
        min-width: 34px;
        height: 34px;
        border: 1px solid rgba(180, 0, 0, 0.25);
        border-radius: 999px;
        background: #fff;
        color: #8b0000;
        font-size: 22px;
        line-height: 1;
        font-weight: 600;
      }

      .ew-editor-delete-selection:disabled {
        opacity: 0.45;
        cursor: not-allowed;
      }

      .ew-editor-grid-toggle {
        min-height: 34px;
        padding: 0 12px;
        border: 1px solid #ddd;
        border-radius: 999px;
        background: #fff;
        color: #1f1966;
        font-size: 13px;
        font-weight: 600;
      }

      .ew-editor-grid-toggle.ew-active {
        border-color: #1f1966;
        background: #f1e8ff;
      }

      .ew-editor-item {
        position: absolute;
        box-sizing: border-box;
        touch-action: none;
      }

      .ew-editor-text {
        min-width: 80px;
        min-height: 40px;
        padding: 6px 8px;
        border: 1px dashed #999;
        background: rgba(255,255,255,0.75);
        cursor: default;
      }

      .ew-editor-text-content {
        width: 100%;
        height: 100%;
        outline: none;
        white-space: pre-wrap;
        word-break: break-word;
        overflow: hidden;
        cursor: text;
        user-select: text;
        -webkit-user-select: text;
      }

      .ew-editor-image {
        border: 1px dashed #999;
        cursor: move;
      }

      .ew-selected {
        outline: 2px solid #111;
      }

      .ew-selected

      .ew-preview-mode


      .ew-editor-item .ew-delete-handle {
        display: none;
        position: absolute;
        top: -12px;
        right: -12px;
        width: 24px;
        height: 24px;
        padding: 0;
        border: 2px solid #000;
        border-radius: 50%;
        background-color: rgb(255, 168, 247);
        background-image: url("data:image/svg+xml,%0A%3Csvg width='18' height='18' viewBox='0 0 18 18' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M4.64315 9.74715L5.48279 9.00005L4.64312 8.25298C2.67261 6.49977 1.62999 4.89778 1.21661 3.65886C0.797785 2.40366 1.0574 1.68849 1.37285 1.37303C1.6883 1.05756 2.40348 0.797922 3.6587 1.21667C4.89763 1.62998 6.49964 2.67249 8.25287 4.64283L8.99994 5.48241L9.747 4.64283C11.5002 2.67248 13.1023 1.62994 14.3412 1.21659C15.5964 0.797791 16.3116 1.05741 16.627 1.37284C16.9425 1.68826 17.2021 2.40338 16.7833 3.65863C16.3699 4.89759 15.3272 6.49965 13.3567 8.253L12.5171 9.00011L13.3568 9.74718C15.3273 11.5004 16.3699 13.1024 16.7834 14.3413C17.2022 15.5965 16.9426 16.3117 16.6272 16.6271C16.3118 16.9425 15.5967 17.2021 14.3414 16.7833C13.1025 16.3699 11.5004 15.3273 9.747 13.3568L8.99991 12.5172L8.25285 13.3568C6.49961 15.3273 4.89758 16.3699 3.65863 16.7834C2.40337 17.2022 1.68822 16.9426 1.37281 16.6272C1.05742 16.3119 0.797777 15.5968 1.21661 14.3415C1.63 13.1026 2.67262 11.5005 4.64315 9.74715Z' fill='white' stroke='black' stroke-width='2'/%3E%3C/svg%3E%0A");
        background-position: center center;
        background-size: 60% auto;
        background-repeat: no-repeat;
        color: transparent;
        font-size: 0;
        line-height: 0;
        cursor: pointer;
        pointer-events: auto;
        touch-action: manipulation;
        z-index: 20;
      }

      .ew-editor-item.ew-selected .ew-delete-handle {
        display: block;
      }

      .ew-preview-mode .ew-delete-handle,
      .ew-export-mode .ew-delete-handle {
        display: none;
      }

      .ew-resize-handle {
        position: absolute;
        right: -6px;
        bottom: -6px;
        width: 12px;
        height: 12px;
        background: #111;
        border-radius: 50%;
        cursor: se-resize;
        z-index: 2;
      }

      .ew-preview-mode .ew-editor-text {
        border-color: transparent;
        background: transparent;
      }

      .ew-preview-mode .ew-editor-image {
        border-color: transparent;
      }

      .ew-preview-mode .ew-selected {
        outline: none;
      }

      .ew-preview-mode .ew-resize-handle {
        display: none;
      }


      .ew-editor-wrap button,
      .ew-editor-wrap .ew-editor-btn,
      .ew-editor-style-control,
      .ew-editor-align-btn {
        border-radius: 999px;
      }

      .ew-editor-text-toolbar {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        gap: 8px;
        flex-wrap: wrap;
        margin-top: 10px;
        padding: 10px 12px;
        border: 1px solid rgba(31, 25, 102, 0.12);
        border-radius: 4px;
        background: #fff;
        box-shadow: 0 4px 14px rgba(31, 25, 102, 0.08);
        opacity: 0.42;
        filter: grayscale(1);
        pointer-events: none;
      }

      .ew-editor-text-toolbar.ew-visible {
        opacity: 1;
        filter: none;
        pointer-events: auto;
      }

      .ew-editor-toolbar-label {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        min-width: 34px;
        height: 34px;
        border-radius: 999px;
        background: #f1e8ff;
        color: #1f1966;
        font-weight: 700;
        font-size: 15px;
      }

      .ew-editor-text-toolbar .ew-editor-style-controls {
        display: flex;
        flex-wrap: wrap;
        gap: 6px;
        align-items: center;
        width: auto;
        padding: 0;
      }

      .ew-editor-text-toolbar .ew-editor-style-control {
        min-height: 34px;
        font-size: 13px;
      }

      .ew-editor-text-toolbar #ew-font-family {
        width: 150px;
      }

      .ew-editor-text-toolbar #ew-font-size {
        width: 58px;
      }

      .ew-editor-text-toolbar #ew-font-color {
        width: 40px;
        height: 34px;
      }

      .ew-editor-text-toolbar #ew-font-color {
        overflow: hidden;
        border-radius: 999px;
      }

      .ew-editor-text-toolbar #ew-font-color::-webkit-color-swatch-wrapper {
        padding: 0;
        border-radius: 999px;
      }

      .ew-editor-text-toolbar #ew-font-color::-webkit-color-swatch {
        border: none;
        border-radius: 999px;
      }

      .ew-editor-text-toolbar #ew-font-color::-moz-color-swatch {
        border: none;
        border-radius: 999px;
      }


      .ew-editor-text-toolbar .ew-editor-align-btn {
        min-width: 34px;
        min-height: 34px;
      }

      .ew-editor-note {
        display: inline-flex;
        align-items: center;
        min-height: 34px;
        padding: 0 12px;
        border: 1px solid rgba(31, 25, 102, 0.25);
        border-radius: 999px;
        background: rgba(255, 255, 255, 0.65);
        color: #1f1966;
        font-size: 12px;
        font-weight: 600;
        margin: 0;
        line-height: 1.2;
        order: 2;
      }

      .ew-open-preview.btn {
        padding: 4px 10px;
        font-size: 13px;
        line-height: 1.2;
        min-height: auto;
      }


      .ew-editor-item

      .ew-editor-item.ew-selected


      .ew-editor-item

      .ew-editor-item.ew-selected


      .ew-editor-item

      .ew-editor-item.ew-selected

      @media (max-width: 767px) {
        .ew-editor-toolbar {
          flex-direction: column;
          align-items: stretch;
        }

        .ew-editor-canvas {
          width: 100%;
        }

        .ew-editor-style-controls {
          grid-template-columns: 1fr 68px 48px;
        }

  

      .ew-editor-color-dropdown {
        position: relative;
        display: inline-flex;
      }

      .ew-editor-color-toggle {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 38px;
        height: 34px;
        border: 1px solid #ddd;
        border-radius: 999px;
        background: #fff;
        padding: 0;
        cursor: pointer;
      }

      .ew-editor-color-preview {
        width: 22px;
        height: 22px;
        border: 1px solid #999;
        border-radius: 999px;
        background: #000;
      }

      .ew-editor-color-menu {
        position: absolute;
        top: calc(100% + 8px);
        left: 50%;
        transform: translateX(-50%);
        z-index: 30;
        display: grid;
        gap: 8px;
        min-width: 190px;
        padding: 10px;
        border: 1px solid rgba(31, 25, 102, 0.18);
        border-radius: 16px;
        background: #fff;
        box-shadow: 0 8px 24px rgba(31, 25, 102, 0.14);
      }

      .ew-editor-color-menu[hidden] {
        display: none;
      }

      .ew-editor-color-menu .ew-editor-color-palette {
        display: flex;
        gap: 8px;
        align-items: center;
        justify-content: center;
      }

.ew-editor-color-menu .ew-editor-hex-input {
        grid-column: 1 / -1;
        width: 110px;
        justify-self: start;
        margin-top: 2px;
        text-align: left;
        padding: 0 12px;
        font-size: 13px;
      }

      .ew-editor-color-palette {
        display: inline-flex;
        gap: 4px;
        align-items: center;
      }

      .ew-editor-color-swatch {
        width: 28px;
        height: 28px;
        min-width: 28px;
        min-height: 28px;
        padding: 0;
        border: 1px solid #ddd;
        border-radius: 999px;
        background: #000;
        cursor: pointer;
      }

      .ew-editor-color-swatch.ew-light {
        border-color: #999;
      }

      .ew-editor-color-swatch.ew-active {
        outline: 2px solid #1f1966;
        outline-offset: 2px;
      }

      .ew-editor-hex-input {
        width: 86px;
        text-transform: uppercase;
        font-size: 12px;
      }

      .ew-editor-align-group {
          grid-column: 1 / -1;
        }
      }

      .ew-editor-item .ew-delete-handle {
        appearance: none !important;
        -webkit-appearance: none !important;
        display: none !important;
        position: absolute !important;
        top: -12px !important;
        right: -12px !important;
        width: 24px !important;
        min-width: 24px !important;
        max-width: 24px !important;
        height: 24px !important;
        min-height: 24px !important;
        max-height: 24px !important;
        padding: 0 !important;
        margin: 0 !important;
        border: 2px solid #000 !important;
        border-radius: 50% !important;
        background-color: rgb(255, 168, 247) !important;
        background-image: url("data:image/svg+xml,%0A%3Csvg width='18' height='18' viewBox='0 0 18 18' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M4.64315 9.74715L5.48279 9.00005L4.64312 8.25298C2.67261 6.49977 1.62999 4.89778 1.21661 3.65886C0.797785 2.40366 1.0574 1.68849 1.37285 1.37303C1.6883 1.05756 2.40348 0.797922 3.6587 1.21667C4.89763 1.62998 6.49964 2.67249 8.25287 4.64283L8.99994 5.48241L9.747 4.64283C11.5002 2.67248 13.1023 1.62994 14.3412 1.21659C15.5964 0.797791 16.3116 1.05741 16.627 1.37284C16.9425 1.68826 17.2021 2.40338 16.7833 3.65863C16.3699 4.89759 15.3272 6.49965 13.3567 8.253L12.5171 9.00011L13.3568 9.74718C15.3273 11.5004 16.3699 13.1024 16.7834 14.3413C17.2022 15.5965 16.9426 16.3117 16.6272 16.6271C16.3118 16.9425 15.5967 17.2021 14.3414 16.7833C13.1025 16.3699 11.5004 15.3273 9.747 13.3568L8.99991 12.5172L8.25285 13.3568C6.49961 15.3273 4.89758 16.3699 3.65863 16.7834C2.40337 17.2022 1.68822 16.9426 1.37281 16.6272C1.05742 16.3119 0.797777 15.5968 1.21661 14.3415C1.63 13.1026 2.67262 11.5005 4.64315 9.74715Z' fill='white' stroke='black' stroke-width='2'/%3E%3C/svg%3E%0A") !important;
        background-position: center center !important;
        background-size: 60% auto !important;
        background-repeat: no-repeat !important;
        box-shadow: none !important;
        text-indent: -9999px !important;
        overflow: hidden !important;
        cursor: pointer !important;
        pointer-events: auto !important;
        touch-action: manipulation !important;
        z-index: 20 !important;
      }

      .ew-editor-item.ew-selected .ew-delete-handle {
        display: block !important;
      }

      .ew-editor-item .ew-delete-handle::before,
      .ew-editor-item .ew-delete-handle::after {
        content: none !important;
        display: none !important;
      }




      /* EW CLEAN: editable-area grid only, no editor centerlines */
      .ew-editor-canvas {
        --ew-editor-bg-image: none;
        --ew-editable-left: 51.13636364%;
        --ew-editable-top: 1.6286645%;
        --ew-editable-width: 47.72727273%;
        --ew-editable-height: 96.74267101%;
        --ew-grid-color: rgba(31, 25, 102, 0.045);
        --ew-border-color: rgba(31, 25, 102, 0.7);

        width: min(100%, 760px) !important;
        aspect-ratio: 440 / 307 !important;
        background-color: #f8f5ef !important;
        background-image: var(--ew-editor-bg-image) !important;
        background-position: center center !important;
        background-size: 100% 100% !important;
        background-repeat: no-repeat !important;
      }

      .ew-editor-canvas::before {
        content: '' !important;
        display: block !important;
        position: absolute !important;
        left: var(--ew-editable-left) !important;
        top: var(--ew-editable-top) !important;
        width: var(--ew-editable-width) !important;
        height: var(--ew-editable-height) !important;
        border: 1px dashed var(--ew-border-color) !important;
        box-sizing: border-box !important;
        pointer-events: none !important;
        z-index: 1 !important;
        background-image:
          repeating-linear-gradient(90deg, var(--ew-grid-color) 0 1px, transparent 1px 24px),
          repeating-linear-gradient(0deg, var(--ew-grid-color) 0 1px, transparent 1px 24px) !important;
        background-position: 0 0, 0 0 !important;
        background-size: 100% 100%, 100% 100% !important;
        background-repeat: no-repeat !important;
      }

      .ew-editor-canvas::after {
        content: 'Personalisierbarer Bereich' !important;
        display: block !important;
        position: absolute !important;
        top: calc(var(--ew-editable-top) + 4px) !important;
        left: calc(var(--ew-editable-left) + 8px) !important;
        font-size: 11px !important;
        line-height: 1.2 !important;
        color: rgba(31, 25, 102, 0.75) !important;
        pointer-events: none !important;
        z-index: 2 !important;
      }

      .ew-static-guide,
      .ew-editor-center-guide,
      .ew-editor-center-guide-x,
      .ew-editor-center-guide-y {
        display: none !important;
      }

      .ew-editor-canvas.ew-grid-hidden::before,
      .ew-editor-canvas.ew-export-mode::before,
      .ew-editor-canvas.ew-grid-hidden::after,
      .ew-editor-canvas.ew-export-mode::after {
        display: none !important;
      }


      /* EW MOBILE: compact controls + focus right area */
      .ew-editor-canvas-viewport {
        width: min(100%, 760px);
        max-width: 100%;
        margin: 0 auto;
        overflow: visible;
        border-radius: 4px;
      }

      .ew-editor-focus-toggle {
        display: none;
      }

      @media (max-width: 767px) {
        .ew-editor-wrap {
          padding: 10px !important;
        }

        .ew-editor-toolbar {
          flex-direction: row !important;
          align-items: center !important;
          gap: 8px !important;
          margin-bottom: 8px !important;
        }

        #ew-add-text,
        .ew-editor-upload {
          flex: 1 1 calc(50% - 4px) !important;
          min-width: 0 !important;
          min-height: 42px !important;
          padding: 0 10px !important;
          font-size: 14px !important;
          line-height: 1.1 !important;
          border-radius: 4px !important;
        }

        .ew-editor-text-toolbar {
          flex: 1 1 100% !important;
          width: 100% !important;
          margin-top: 0 !important;
          padding: 8px !important;
          gap: 6px !important;
          border-radius: 4px !important;
        }

        .ew-editor-toolbar-label {
          width: 38px !important;
          height: 38px !important;
          min-width: 38px !important;
          font-size: 18px !important;
          border-radius: 999px !important;
        }

        .ew-editor-grid-toggle,
        .ew-editor-focus-toggle {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          min-width: 0 !important;
          min-height: 36px !important;
          padding: 0 10px !important;
          font-size: 13px !important;
          line-height: 1.1 !important;
          border-radius: 4px !important;
        }

        .ew-editor-style-controls {
          grid-template-columns: minmax(0, 1fr) 58px 42px !important;
          gap: 6px !important;
          width: 100% !important;
        }

        .ew-editor-style-control {
          min-height: 36px !important;
          font-size: 14px !important;
          border-radius: 4px !important;
        }

        .ew-editor-align-group {
          grid-column: 1 / -1 !important;
        }

        .ew-editor-align-btn {
          min-width: 38px !important;
          min-height: 38px !important;
          border-radius: 4px !important;
        }

        .ew-editor-canvas-viewport {
          width: 100% !important;
          max-width: 100% !important;
        }

        .ew-editor-canvas-viewport.ew-focus-right {
          aspect-ratio: 105 / 148.5 !important;
          overflow: hidden !important;
          background: #fff !important;
          border: 1px solid rgba(31, 25, 102, 0.18) !important;
        }

        .ew-editor-canvas-viewport.ew-focus-right .ew-editor-canvas {
          left: -107.14285714% !important;
          top: -1.68350168% !important;
          margin: 0 !important;
          transform: scale(2.0952380952) !important;
          transform-origin: 0 0 !important;
        }
      }
      /* /EW MOBILE */


      /* EW MOBILE FOCUS BUTTON: floating arrow + desktop-like radius */
      @media (max-width: 767px) {
        #ew-add-text,
        .ew-editor-upload,
        .ew-editor-grid-toggle,
        .ew-editor-align-btn {
          border-radius: 999px !important;
        }

        .ew-editor-canvas-viewport {
          position: relative !important;
        }

        .ew-editor-canvas-viewport > .ew-editor-focus-toggle {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          position: absolute !important;
          top: 8px !important;
          right: 8px !important;
          z-index: 30 !important;
          width: 38px !important;
          height: 38px !important;
          min-width: 38px !important;
          min-height: 38px !important;
          padding: 0 !important;
          border: 2px solid #1f1966 !important;
          border-radius: 999px !important;
          background: rgba(255, 255, 255, 0.92) !important;
          color: #1f1966 !important;
          font-size: 20px !important;
          font-weight: 700 !important;
          line-height: 1 !important;
          box-shadow: 0 4px 12px rgba(31, 25, 102, 0.14) !important;
          pointer-events: auto !important;
          opacity: 1 !important;
          filter: none !important;
        }

        .ew-editor-canvas-viewport.ew-focus-right > .ew-editor-focus-toggle {
          background: #f1e8ff !important;
        }
      }
      /* /EW MOBILE FOCUS BUTTON */


      /* EW MOBILE FOCUS REFINEMENT: modern icon + exact viewport */
      @media (max-width: 767px) {
        .ew-editor-canvas-viewport.ew-focus-right {
          box-sizing: border-box !important;
        }

        .ew-editor-canvas-viewport.ew-focus-right .ew-editor-canvas::after {
          display: none !important;
        }

        .ew-editor-canvas-viewport > .ew-editor-focus-toggle {
          width: 44px !important;
          height: 44px !important;
          min-width: 44px !important;
          min-height: 44px !important;
          top: 10px !important;
          right: 10px !important;
          border-radius: 999px !important;
        }

        .ew-editor-canvas-viewport > .ew-editor-focus-toggle svg {
          width: 27px !important;
          height: 27px !important;
          display: block !important;
          fill: none !important;
          stroke: currentColor !important;
          stroke-width: 2.4 !important;
          stroke-linecap: round !important;
          stroke-linejoin: round !important;
        }
      }
      /* /EW MOBILE FOCUS REFINEMENT */


      /* EW MOBILE FOCUS FINAL: exact right-area crop + modern icon */
      @media (max-width: 767px) {
        .ew-editor-canvas-viewport.ew-focus-right {
          aspect-ratio: 105 / 148.5 !important;
          overflow: hidden !important;
          box-sizing: border-box !important;
        }

        .ew-editor-canvas-viewport.ew-focus-right .ew-editor-canvas {
          left: 0 !important;
          top: 0 !important;
          margin: 0 !important;
          transform-origin: 0 0 !important;
          transform: scale(2.0952380952) translate(-50.95%, -1.6286645%) !important;
        }

        .ew-editor-canvas-viewport.ew-focus-right .ew-editor-canvas::after {
          display: none !important;
        }

        .ew-editor-canvas-viewport > .ew-editor-focus-toggle {
          width: 44px !important;
          height: 44px !important;
          min-width: 44px !important;
          min-height: 44px !important;
          top: 10px !important;
          right: 10px !important;
          border: 3px solid #1f1966 !important;
          border-radius: 999px !important;
          background: rgba(255, 255, 255, 0.96) !important;
          color: #1f1966 !important;
          box-shadow: 0 4px 12px rgba(31, 25, 102, 0.14) !important;
        }

        .ew-editor-canvas-viewport > .ew-editor-focus-toggle svg {
          width: 31px !important;
          height: 31px !important;
          display: block !important;
          fill: none !important;
          stroke: currentColor !important;
          stroke-width: 2.8 !important;
          stroke-linecap: round !important;
          stroke-linejoin: round !important;
        }
      }
      /* /EW MOBILE FOCUS FINAL */


      /* EW EDITOR ITEMS: finer borders + hide editable-area label once content exists */
      .ew-editor-text,
      .ew-editor-image {
        border-width: 0.5px !important;
        border-color: rgba(31, 25, 102, 0.35) !important;
      }

      .ew-selected,
      .ew-editor-text.ew-selected,
      .ew-editor-image.ew-selected {
        outline: 0.5px solid rgba(31, 25, 102, 0.85) !important;
        outline-offset: 0 !important;
      }

      .ew-resize-handle {
        width: 8px !important;
        height: 8px !important;
        right: -4px !important;
        bottom: -4px !important;
      }

      .ew-editor-canvas.ew-has-items::after {
        display: none !important;
      }
      /* /EW EDITOR ITEMS */


      /* EW MOBILE: proportional smaller delete handle in focus mode */
      @media (max-width: 767px) {
        .ew-editor-canvas-viewport.ew-focus-right .ew-editor-item .ew-delete-handle {
          width: 15px !important;
          min-width: 15px !important;
          max-width: 15px !important;
          height: 15px !important;
          min-height: 15px !important;
          max-height: 15px !important;
          top: -7.5px !important;
          right: -7.5px !important;
          border-width: 1.25px !important;
          background-size: 62% auto !important;
        }

        .ew-editor-canvas-viewport.ew-focus-right .ew-resize-handle {
          width: 5px !important;
          height: 5px !important;
          right: -2.5px !important;
          bottom: -2.5px !important;
        }
      }
      /* /EW MOBILE DELETE HANDLE */


      /* EW MOBILE: safer toolbar layout + normal-view item handles */
      @media (max-width: 767px) {
        .ew-editor-style-controls {
          display: grid !important;
          grid-template-columns: minmax(0, 1fr) 56px !important;
          gap: 6px !important;
          width: 100% !important;
          max-width: 100% !important;
          box-sizing: border-box !important;
        }

        .ew-editor-style-controls > * {
          min-width: 0 !important;
          box-sizing: border-box !important;
        }

        .ew-editor-style-controls input[type="color"],
        .ew-editor-color-control,
        .ew-editor-color {
          grid-column: 1 / -1 !important;
          justify-self: start !important;
          max-width: 44px !important;
          width: 44px !important;
          height: 44px !important;
        }

        .ew-editor-style-control {
          width: 100% !important;
          max-width: 100% !important;
        }

        .ew-editor-align-group {
          grid-column: 1 / -1 !important;
        }

        .ew-editor-canvas:not(.ew-export-mode) .ew-delete-handle {
          width: 20px !important;
          min-width: 20px !important;
          max-width: 20px !important;
          height: 20px !important;
          min-height: 20px !important;
          max-height: 20px !important;
          top: -10px !important;
          right: -10px !important;
          border-width: 1.5px !important;
          background-size: 62% auto !important;
        }

        .ew-editor-canvas:not(.ew-export-mode) .ew-resize-handle {
          width: 6px !important;
          height: 6px !important;
          right: -3px !important;
          bottom: -3px !important;
        }

        .ew-editor-canvas-viewport.ew-focus-right .ew-editor-item .ew-delete-handle {
          width: 15px !important;
          min-width: 15px !important;
          max-width: 15px !important;
          height: 15px !important;
          min-height: 15px !important;
          max-height: 15px !important;
          top: -7.5px !important;
          right: -7.5px !important;
        }

        .ew-editor-canvas-viewport.ew-focus-right .ew-resize-handle {
          width: 5px !important;
          height: 5px !important;
          right: -2.5px !important;
          bottom: -2.5px !important;
        }
      }
      /* /EW MOBILE TOOLBAR FIX */


      /* EW TEXT EDITING: finer inner text outline */
      .ew-editor-text-content {
        outline: none !important;
      }

      .ew-editor-text.ew-selected .ew-editor-text-content:focus {
        outline: 1px dotted rgba(31, 25, 102, 0.45) !important;
        outline-offset: 1px !important;
      }

      @media (max-width: 767px) {
        .ew-editor-text.ew-selected .ew-editor-text-content:focus {
          outline: 0.5px dotted rgba(31, 25, 102, 0.4) !important;
          outline-offset: 1px !important;
        }
      }
      /* /EW TEXT EDITING */


      /* EW MOBILE: compact color menu */
      @media (max-width: 767px) {
        .ew-editor-text-toolbar .ew-editor-color-dropdown {
          position: relative !important;
          width: 44px !important;
          max-width: 44px !important;
          min-width: 44px !important;
          justify-self: start !important;
        }

        .ew-editor-text-toolbar .ew-editor-color-toggle {
          width: 44px !important;
          height: 44px !important;
          min-width: 44px !important;
          min-height: 44px !important;
          padding: 0 !important;
        }

        .ew-editor-text-toolbar .ew-editor-color-preview {
          width: 28px !important;
          height: 28px !important;
        }

        .ew-editor-text-toolbar .ew-editor-color-menu {
          position: absolute !important;
          top: calc(100% + 6px) !important;
          left: 0 !important;
          right: auto !important;
          transform: none !important;
          width: 108px !important;
          min-width: 108px !important;
          max-width: 108px !important;
          padding: 7px !important;
          border-radius: 4px !important;
          box-sizing: border-box !important;
          overflow: hidden !important;
          z-index: 40000 !important;
        }

        .ew-editor-text-toolbar .ew-editor-color-menu[hidden] {
          display: none !important;
        }

        .ew-editor-text-toolbar .ew-editor-color-menu:not([hidden]) {
          display: grid !important;
          grid-template-columns: 1fr !important;
          gap: 7px !important;
        }

        .ew-editor-text-toolbar .ew-editor-color-menu .ew-editor-color-palette {
          display: grid !important;
          grid-template-columns: repeat(4, 20px) !important;
          gap: 5px !important;
          justify-content: center !important;
          justify-items: center !important;
          width: 100% !important;
        }

        .ew-editor-text-toolbar .ew-editor-color-swatch {
          width: 20px !important;
          height: 20px !important;
          min-width: 20px !important;
          min-height: 20px !important;
          border-width: 1px !important;
        }

        .ew-editor-text-toolbar .ew-editor-color-menu #ew-font-color.ew-editor-hex-input {
          width: 86px !important;
          min-width: 86px !important;
          max-width: 86px !important;
          height: 30px !important;
          min-height: 30px !important;
          padding: 0 6px !important;
          font-size: 11px !important;
          line-height: 30px !important;
          border-radius: 4px !important;
          justify-self: center !important;
          text-align: center !important;
        }
      }
      /* /EW MOBILE COLOR MENU */


      /* EW MOBILE: compact 2-line formatting toolbar + align icons */
      @media (max-width: 767px) {
        .ew-editor-text-toolbar {
          display: grid !important;
          grid-template-columns: 44px minmax(128px, 230px) 54px 44px !important;
          grid-template-areas:
            "label font size color"
            "grid grid align align" !important;
          justify-content: start !important;
          align-items: center !important;
          gap: 7px !important;
          padding: 8px !important;
          width: 100% !important;
          max-width: 100% !important;
          box-sizing: border-box !important;
        }

        .ew-editor-text-toolbar .ew-editor-toolbar-label {
          grid-area: label !important;
          width: 44px !important;
          min-width: 44px !important;
          height: 44px !important;
        }

        .ew-editor-text-toolbar #ew-toggle-grid {
          grid-area: grid !important;
          justify-self: start !important;
          min-height: 38px !important;
          padding: 0 14px !important;
        }

        .ew-editor-text-toolbar .ew-editor-style-controls {
          display: contents !important;
        }

        .ew-editor-text-toolbar #ew-font-family {
          grid-area: font !important;
          width: 100% !important;
          max-width: 230px !important;
          min-width: 0 !important;
          height: 42px !important;
          color: #111 !important;
          background: #fff !important;
          font-family: Arial, sans-serif !important;
        }

        .ew-editor-text-toolbar #ew-font-size {
          grid-area: size !important;
          width: 54px !important;
          min-width: 54px !important;
          height: 42px !important;
        }

        .ew-editor-text-toolbar .ew-editor-color-dropdown {
          grid-area: color !important;
          width: 44px !important;
          min-width: 44px !important;
          position: relative !important;
        }

        .ew-editor-text-toolbar .ew-editor-color-toggle {
          width: 44px !important;
          height: 44px !important;
          min-width: 44px !important;
          min-height: 44px !important;
        }

        .ew-editor-text-toolbar .ew-editor-color-menu {
          right: 0 !important;
          left: auto !important;
          transform: none !important;
        }

        .ew-editor-text-toolbar .ew-editor-align-group {
          grid-area: align !important;
          display: grid !important;
          grid-template-columns: repeat(3, 36px) !important;
          gap: 6px !important;
          justify-self: end !important;
        }

        .ew-editor-text-toolbar .ew-editor-align-btn {
          width: 36px !important;
          min-width: 36px !important;
          height: 36px !important;
          min-height: 36px !important;
          padding: 0 !important;
          border-radius: 4px !important;
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
        }

        .ew-editor-text-toolbar .ew-editor-align-btn svg {
          width: 23px !important;
          height: 23px !important;
          display: block !important;
          fill: none !important;
          stroke: currentColor !important;
          stroke-width: 1.8 !important;
          stroke-linecap: round !important;
        }
      }
      /* /EW MOBILE COMPACT TOOLBAR */


      /* EW MOBILE: smaller focus zoom button */
      @media (max-width: 767px) {
        .ew-editor-canvas-viewport > .ew-editor-focus-toggle {
          width: 34px !important;
          height: 34px !important;
          min-width: 34px !important;
          min-height: 34px !important;
          top: 4px !important;
          right: 4px !important;
          border-width: 2.5px !important;
          box-shadow: 0 3px 8px rgba(31, 25, 102, 0.12) !important;
        }

        .ew-editor-canvas-viewport > .ew-editor-focus-toggle svg {
          width: 23px !important;
          height: 23px !important;
          stroke-width: 2.8 !important;
        }
      }
      /* /EW MOBILE SMALLER FOCUS BUTTON */


      /* EW PRINT QUALITY: image resolution warning */
      .ew-editor-resolution-message {
        display: none;
        width: 100%;
        box-sizing: border-box;
        margin: 8px 0 0;
        padding: 9px 11px;
        border-radius: 4px;
        border: 1px solid rgba(31, 25, 102, 0.2);
        background: #fff7d6;
        color: #1f1966;
        font-size: 13px;
        line-height: 1.35;
      }

      .ew-editor-resolution-message.ew-visible {
        display: block;
      }

      .ew-editor-resolution-message.ew-error {
        border-color: rgba(190, 0, 0, 0.35);
        background: #fff0f0;
      }
      /* /EW PRINT QUALITY */


      /* EW DESKTOP: align icons + compact two-line color menu */
      @media (min-width: 768px) {
        .ew-editor-align-btn {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          padding: 0 !important;
        }

        .ew-editor-align-btn svg {
          width: 24px !important;
          height: 24px !important;
          display: block !important;
          fill: none !important;
          stroke: currentColor !important;
          stroke-width: 1.8 !important;
          stroke-linecap: round !important;
        }

        .ew-editor-color-menu {
          width: 318px !important;
          max-width: 318px !important;
          min-width: 318px !important;
          padding: 12px !important;
          border-radius: 4px !important;
          box-sizing: border-box !important;
        }

        .ew-editor-color-menu:not([hidden]) {
          display: grid !important;
          grid-template-columns: 1fr !important;
          gap: 10px !important;
        }

        .ew-editor-color-palette {
          display: grid !important;
          grid-template-columns: repeat(6, 42px) !important;
          gap: 9px !important;
          justify-content: center !important;
          justify-items: center !important;
        }

        .ew-editor-color-swatch {
          width: 42px !important;
          height: 42px !important;
          min-width: 42px !important;
          min-height: 42px !important;
          border-width: 1px !important;
        }

        #ew-font-color.ew-editor-hex-input,
        .ew-editor-color-menu .ew-editor-hex-input {
          width: 112px !important;
          max-width: 112px !important;
          min-width: 112px !important;
          height: 38px !important;
          justify-self: center !important;
          text-align: center !important;
          border-radius: 4px !important;
        }
      }
      /* /EW DESKTOP COLOR ALIGN */


      /* EW TEXT FORMAT: bold/underline without extra toolbar row */
      .ew-editor-actions-group,
      .ew-editor-format-group {
        display: inline-flex;
        align-items: center;
        justify-content: flex-start;
        gap: 8px;
      }

      .ew-editor-format-btn {
        width: 44px;
        min-width: 44px;
        height: 44px;
        min-height: 44px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        padding: 0;
        border: 1px solid rgba(31, 25, 102, 0.18);
        border-radius: 999px;
        background: #fff;
        color: #1f1966;
        font-size: 18px;
        line-height: 1;
        cursor: pointer;
      }

      .ew-editor-format-btn.ew-active {
        border-color: #1f1966;
        box-shadow: inset 0 0 0 1px #1f1966;
      }

      .ew-format-u {
        text-decoration: underline;
        text-underline-offset: 3px;
        font-weight: 700;
      }

      @media (max-width: 767px) {
        .ew-editor-text-toolbar {
          grid-template-columns: 44px minmax(96px, 1fr) 50px 44px !important;
          grid-template-areas:
            "label font size color"
            "grid actions actions actions" !important;
        }

        .ew-editor-text-toolbar .ew-editor-actions-group {
          grid-area: actions !important;
          display: inline-flex !important;
          justify-self: end !important;
          align-items: center !important;
          gap: 5px !important;
        }

        .ew-editor-text-toolbar .ew-editor-format-group,
        .ew-editor-text-toolbar .ew-editor-align-group {
          display: inline-flex !important;
          align-items: center !important;
          gap: 5px !important;
        }

        .ew-editor-text-toolbar .ew-editor-format-btn,
        .ew-editor-text-toolbar .ew-editor-align-btn {
          width: 32px !important;
          min-width: 32px !important;
          height: 32px !important;
          min-height: 32px !important;
          border-radius: 999px !important;
        }

        .ew-editor-text-toolbar .ew-editor-format-btn {
          font-size: 15px !important;
        }

        .ew-editor-text-toolbar .ew-editor-align-btn svg {
          width: 19px !important;
          height: 19px !important;
        }

        .ew-editor-text-toolbar #ew-toggle-grid {
          grid-area: grid !important;
          justify-self: start !important;
          min-height: 34px !important;
          padding: 0 12px !important;
        }
      }
      /* /EW TEXT FORMAT */


      /* EW TEXT FORMAT REFINEMENT: same size as align buttons */
      .ew-editor-format-btn {
        width: 44px !important;
        min-width: 44px !important;
        height: 44px !important;
        min-height: 44px !important;
        border-radius: 999px !important;
        font-size: 18px !important;
      }

      .ew-editor-format-btn strong {
        font-weight: 700 !important;
      }

      .ew-format-u {
        text-decoration: underline !important;
        text-underline-offset: 4px !important;
        font-weight: 700 !important;
      }

      @media (max-width: 767px) {
        .ew-editor-text-toolbar .ew-editor-format-btn,
        .ew-editor-text-toolbar .ew-editor-align-btn {
          width: 36px !important;
          min-width: 36px !important;
          height: 36px !important;
          min-height: 36px !important;
        }

        .ew-editor-text-toolbar .ew-editor-format-btn {
          font-size: 17px !important;
        }
      }
      /* /EW TEXT FORMAT REFINEMENT */


      /* EW FINAL: only F/U buttons smaller */
      .ew-editor-text-toolbar .ew-editor-format-btn {
        width: 36px !important;
        min-width: 36px !important;
        max-width: 36px !important;
        height: 36px !important;
        min-height: 36px !important;
        max-height: 36px !important;
        flex: 0 0 36px !important;
        padding: 0 !important;
        box-sizing: border-box !important;
        font-size: 16px !important;
        line-height: 1 !important;
      }

      @media (max-width: 767px) {
        .ew-editor-text-toolbar .ew-editor-format-btn {
          width: 32px !important;
          min-width: 32px !important;
          max-width: 32px !important;
          height: 32px !important;
          min-height: 32px !important;
          max-height: 32px !important;
          flex-basis: 32px !important;
          font-size: 15px !important;
        }
      }
      /* /EW FINAL FORMAT BUTTONS ONLY */


      /* EW FINAL: thinner F/U borders */
      .ew-editor-text-toolbar .ew-editor-format-btn {
        border-width: 1px !important;
        box-shadow: none !important;
      }

      .ew-editor-text-toolbar .ew-editor-format-btn.ew-active {
        border-width: 1px !important;
        border-color: #1f1966 !important;
        box-shadow: none !important;
      }
      /* /EW FINAL THIN FORMAT BORDERS */


      /* EW EDITOR: inside view label */
      .ew-editor-inside-view-label {
        width: min(100%, 760px);
        margin: 10px auto 8px;
        color: #1f1966;
        font-size: 15px;
        line-height: 1.2;
        font-weight: 600;
        text-align: left;
      }

      @media (max-width: 767px) {
        .ew-editor-inside-view-label {
          margin: 8px auto 6px;
          font-size: 13px;
        }
      }
      /* /EW EDITOR INSIDE VIEW LABEL */


      /* EW COPY/SPACING: inside personalization labels */
      .ew-editor-inside-view-label {
        width: min(100%, 760px) !important;
        margin: 4px auto 4px !important;
        color: #1f1966 !important;
        font-size: 15px !important;
        line-height: 1.2 !important;
        font-weight: 700 !important;
        text-align: center !important;
      }

      .ew-editor-inside-view-label + .ew-editor-canvas-viewport {
        margin-top: 0 !important;
      }

      [id^="ewPersonalizationCanvas-"] .offcanvas-header {
        padding-bottom: 4px !important;
      }

      [id^="ewPersonalizationCanvas-"] .offcanvas-body {
        padding-top: 0 !important;
      }

      [id^="ewPersonalizationCanvas-"] .offcanvas-title,
      [id^="ewPersonalizationCanvas-"] h1,
      [id^="ewPersonalizationCanvas-"] h2 {
        margin-bottom: 4px !important;
      }

      [id^="ewPersonalizationCanvas-"] [id^="ew-card-editor-"] {
        margin-top: 8px !important;
      }

      @media (max-width: 767px) {
        .ew-editor-inside-view-label {
          margin: 3px auto 3px !important;
          font-size: 13px !important;
        }
      }
      /* /EW COPY SPACING */


      /* EW FINAL: tighter inside-view label spacing */
      .ew-editor-inside-view-label {
        width: min(100%, 760px) !important;
        margin: 2px auto 0 !important;
        color: #1f1966 !important;
        font-size: 15px !important;
        line-height: 1.1 !important;
        font-weight: 700 !important;
        text-align: center !important;
      }

      .ew-editor-inside-view-label + .ew-editor-canvas-viewport {
        margin-top: 0 !important;
      }

      @media (max-width: 767px) {
        .ew-editor-inside-view-label {
          margin: 1px auto 0 !important;
          font-size: 13px !important;
        }
      }
      /* /EW FINAL INSIDE LABEL TIGHT */


      /* EW FINAL: inside title spacing */
      .ew-editor-canvas-wrap {
        gap: 6px !important;
      }

      .ew-editor-inside-view-label {
        width: min(100%, 760px) !important;
        margin: 0 auto -3px !important;
        color: #1f1966 !important;
        font-size: 15px !important;
        line-height: 1.1 !important;
        font-weight: 700 !important;
        text-align: center !important;
      }

      @media (max-width: 767px) {
        .ew-editor-canvas-wrap {
          gap: 5px !important;
        }

        .ew-editor-inside-view-label {
          margin: 0 auto -3px !important;
          font-size: 13px !important;
        }
      }
      /* /EW FINAL INSIDE TITLE SPACING */


      /* EW OFFCANVAS: keep personalization editor above sticky header/footer */
      [id^="ewPersonalizationCanvas-"] {
        z-index: 2147483000 !important;
        top: 0 !important;
        height: 100dvh !important;
      }

      body:has([id^="ewPersonalizationCanvas-"].show) .offcanvas-backdrop {
        z-index: 2147482990 !important;
      }

      [id^="ewPersonalizationCanvas-"] .offcanvas-header,
      [id^="ewPersonalizationCanvas-"] .offcanvas-body {
        position: relative !important;
        z-index: 1 !important;
      }

      [id^="ewPersonalizationCanvas-"] .offcanvas-body {
        flex: 1 1 auto !important;
        overflow-y: auto !important;
        overscroll-behavior: contain !important;
      }
      /* /EW OFFCANVAS ZINDEX */


      /* EW MOBILE: clearer expand/collapse zoom icon */
      @media (max-width: 767px) {
        .ew-editor-canvas-viewport > .ew-editor-focus-toggle svg {
          width: 22px !important;
          height: 22px !important;
          stroke-width: 2.5 !important;
          stroke-linecap: round !important;
          stroke-linejoin: round !important;
        }
      }
      /* /EW MOBILE ZOOM ICON */


      /* EW MOBILE: make offcanvas content scroll instead of page behind */
      @media (max-width: 767px) {
        body:has([id^="ewPersonalizationCanvas-"].show) {
          overflow: hidden !important;
          touch-action: none !important;
        }

        [id^="ewPersonalizationCanvas-"].show .offcanvas-body {
          -webkit-overflow-scrolling: touch !important;
          touch-action: pan-y !important;
        }

        .offcanvas.show:not([id^="ewPersonalizationCanvas-"]) {
          overflow: hidden !important;
          max-height: 100dvh !important;
        }

        .offcanvas.show:not([id^="ewPersonalizationCanvas-"]) .offcanvas-body,
        .offcanvas.show:not([id^="ewPersonalizationCanvas-"]) .cart-drawer,
        .offcanvas.show:not([id^="ewPersonalizationCanvas-"]) .ajax-cart,
        .offcanvas.show:not([id^="ewPersonalizationCanvas-"]) [class*="cart"] {
          overflow-y: auto !important;
          -webkit-overflow-scrolling: touch !important;
          overscroll-behavior: contain !important;
          touch-action: pan-y !important;
        }
      }
      /* /EW MOBILE OFFCANVAS SCROLL */

/* EW OFFCANVAS: desktop-only drawer layer/scroll fix */
@media (min-width: 768px) {
  html.ew-personalization-open,
  body.ew-personalization-open {
    overflow: hidden !important;
    overscroll-behavior: none !important;
  }

  body.ew-personalization-open {
    touch-action: auto !important;
  }

  /* Alles außerhalb der Personalisierung darf nicht darüber klicken oder layern */
  body.ew-personalization-open > *:not([id^="ewPersonalizationCanvas-"]):not(.offcanvas-backdrop):not(script):not(style) {
    pointer-events: none !important;
    z-index: 0 !important;
  }

  /* Backdrop bleibt zwischen Shop-Seite und Personalisierungs-Offcanvas */
  body.ew-personalization-open > .offcanvas-backdrop,
  body:has([id^="ewPersonalizationCanvas-"].show) > .offcanvas-backdrop {
    z-index: 2147483645 !important;
    opacity: 1 !important;
    background-color: rgba(31, 25, 102, 0.26) !important;
    backdrop-filter: blur(4px) !important;
    -webkit-backdrop-filter: blur(4px) !important;
    pointer-events: auto !important;
  }

  /* Personalisierung bleibt ein rechter Offcanvas, kein Vollbild */
  [id^="ewPersonalizationCanvas-"].offcanvas {
    z-index: 2147483647 !important;
    height: 100dvh !important;
    max-height: 100dvh !important;
    display: flex !important;
    flex-direction: column !important;
    overflow: hidden !important;
    background: #fff !important;
  }

  /* Wichtig: rechter Einschub beibehalten */
  [id^="ewPersonalizationCanvas-"].offcanvas.offcanvas-end {
    top: 0 !important;
    right: 0 !important;
    bottom: 0 !important;
    left: auto !important;

    width: var(--bs-offcanvas-width, min(92vw, 860px)) !important;
    max-width: calc(100vw - 24px) !important;

    transform: translateX(100%) !important;
  }

  [id^="ewPersonalizationCanvas-"].offcanvas.offcanvas-end.show,
  [id^="ewPersonalizationCanvas-"].offcanvas.offcanvas-end.showing {
    transform: translateX(0) !important;
    visibility: visible !important;
  }

  [id^="ewPersonalizationCanvas-"].offcanvas.offcanvas-end.hiding {
    transform: translateX(100%) !important;
  }

  [id^="ewPersonalizationCanvas-"] .offcanvas-header,
  [id^="ewPersonalizationCanvas-"] .offcanvas-footer,
  [id^="ewPersonalizationCanvas-"] .modal-footer {
    flex: 0 0 auto !important;
    position: relative !important;
    z-index: 4 !important;
    background: #fff !important;
  }

  [id^="ewPersonalizationCanvas-"] .offcanvas-body {
    flex: 1 1 auto !important;
    min-height: 0 !important;
    height: auto !important;
    max-height: none !important;

    overflow-y: auto !important;
    overflow-x: hidden !important;

    -webkit-overflow-scrolling: touch !important;
    overscroll-behavior: contain !important;
    touch-action: pan-y !important;

    position: relative !important;
    z-index: 2 !important;

    padding-bottom: calc(32px + env(safe-area-inset-bottom, 0px)) !important;
  }

  [id^="ewPersonalizationCanvas-"] button[id^="ew-apply-personalization-"],
  [id^="ewPersonalizationCanvas-"] .ew-apply-personalization {
    position: relative !important;
    z-index: 6 !important;
    pointer-events: auto !important;
  }

  body.ew-personalization-open .offcanvas.show:not([id^="ewPersonalizationCanvas-"]) {
    z-index: 2147483000 !important;
    pointer-events: none !important;
  }
}

/* EW MOBILE: desktop scroll/layer fix ausdrücklich ausschließen */
@media (max-width: 767px) {
  html.ew-personalization-open,
  body.ew-personalization-open {
    overscroll-behavior: auto !important;
  }

  body.ew-personalization-open,
  body:has([id^="ewPersonalizationCanvas-"].show) {
    touch-action: auto !important;
  }

  [id^="ewPersonalizationCanvas-"].offcanvas {
    z-index: 2147483000 !important;
    height: 100dvh !important;
    max-height: 100dvh !important;
    display: flex !important;
    flex-direction: column !important;
    overflow: hidden !important;
  }

  [id^="ewPersonalizationCanvas-"] .offcanvas-body {
    flex: 1 1 auto !important;
    min-height: 0 !important;
    overflow-y: auto !important;
    overflow-x: hidden !important;
    -webkit-overflow-scrolling: touch !important;
    overscroll-behavior: contain !important;
    touch-action: pan-y !important;
  }

  [id^="ewPersonalizationCanvas-"] .ew-editor-canvas-viewport,
  [id^="ewPersonalizationCanvas-"] .ew-editor-canvas,
  [id^="ewPersonalizationCanvas-"] .ew-editor-item,
  [id^="ewPersonalizationCanvas-"] .ew-editor-text-content,
  [id^="ewPersonalizationCanvas-"] button {
    pointer-events: auto !important;
  }
}
/* /EW OFFCANVAS */

/* EW MOBILE: prevent native input/text focus zoom + keep zoom button visible */
@media (max-width: 767px) {
  .ew-editor-text-content {
    -webkit-text-size-adjust: 100% !important;
    text-size-adjust: 100% !important;
  }

  /*
    Auch Toolbar-Felder auf 16px halten, damit iOS nicht beim Schriftgrößen-
    oder Farbcode-Feld hineinzoomt.
  */
  .ew-editor-wrap input:not([type="color"]),
  .ew-editor-wrap select,
  .ew-editor-wrap textarea {
    font-size: 16px !important;
    -webkit-text-size-adjust: 100% !important;
    text-size-adjust: 100% !important;
  }

  .ew-editor-canvas-viewport {
    position: relative !important;
  }

  .ew-editor-canvas-viewport > .ew-editor-focus-toggle {
    display: inline-flex !important;
    visibility: visible !important;
    opacity: 1 !important;
    filter: none !important;
    pointer-events: auto !important;
    touch-action: manipulation !important;
    z-index: 2147483647 !important;

    align-items: center !important;
    justify-content: center !important;

    width: 46px !important;
    min-width: 46px !important;
    max-width: 46px !important;
    height: 46px !important;
    min-height: 46px !important;
    max-height: 46px !important;

    padding: 0 !important;
    border: 3px solid #1f1966 !important;
    border-radius: 999px !important;
    background: rgba(255, 255, 255, 0.96) !important;
    color: #1f1966 !important;
    box-shadow: 0 4px 12px rgba(31, 25, 102, 0.14) !important;
  }

  .ew-editor-canvas-viewport > .ew-editor-focus-toggle::before {
    content: "" !important;
    position: absolute !important;
    inset: -10px !important;
    border-radius: 999px !important;
  }

  .ew-editor-canvas-viewport:not(.ew-focus-right) > .ew-editor-focus-toggle {
    position: absolute !important;
    top: 4px !important;
    right: 4px !important;
  }

  .ew-editor-canvas-viewport.ew-focus-right > .ew-editor-focus-toggle {
    position: fixed !important;
    top: calc(10px + env(safe-area-inset-top, 0px)) !important;
    right: calc(10px + env(safe-area-inset-right, 0px)) !important;
  }

  .ew-editor-canvas-viewport > .ew-editor-focus-toggle svg {
    width: 28px !important;
    height: 28px !important;
    display: block !important;
    fill: none !important;
    stroke: currentColor !important;
    stroke-width: 2.7 !important;
    stroke-linecap: round !important;
    stroke-linejoin: round !important;
  }
}
/* /EW MOBILE TEXT ZOOM + BUTTON FIX */

/* EW MOBILE: floating zoom-out button inside personalization panel */
@media (max-width: 767px) {
  [id^="ewPersonalizationCanvas-"] .ew-editor-focus-toggle.ew-focus-toggle-floating {
    display: inline-flex !important;
    visibility: visible !important;
    opacity: 1 !important;
    filter: none !important;
    pointer-events: auto !important;
    touch-action: manipulation !important;

    position: absolute !important;
    top: var(--ew-focus-toggle-floating-top, 8px) !important;
    left: var(--ew-focus-toggle-floating-left, auto) !important;
    right: auto !important;
    bottom: auto !important;

    z-index: 50 !important;

    align-items: center !important;
    justify-content: center !important;

    width: 46px !important;
    min-width: 46px !important;
    max-width: 46px !important;
    height: 46px !important;
    min-height: 46px !important;
    max-height: 46px !important;

    padding: 0 !important;
    margin: 0 !important;

    border: 3px solid #1f1966 !important;
    border-radius: 999px !important;
    background: rgba(255, 255, 255, 0.98) !important;
    color: #1f1966 !important;
    box-shadow: 0 4px 14px rgba(31, 25, 102, 0.18) !important;

    transform: none !important;
  }

  [id^="ewPersonalizationCanvas-"] .ew-editor-focus-toggle.ew-focus-toggle-floating::before {
    content: "" !important;
    position: absolute !important;
    inset: -10px !important;
    border-radius: 999px !important;
  }

  [id^="ewPersonalizationCanvas-"] .ew-editor-focus-toggle.ew-focus-toggle-floating svg {
    width: 28px !important;
    height: 28px !important;
    display: block !important;
    fill: none !important;
    stroke: currentColor !important;
    stroke-width: 2.7 !important;
    stroke-linecap: round !important;
    stroke-linejoin: round !important;
  }
}
/* /EW MOBILE FLOATING ZOOM OUT BUTTON */

    </style>

    <div class="ew-editor-wrap">
      <div class="ew-editor-layout">
        <div class="ew-editor-canvas-wrap">
          <div class="ew-editor-toolbar">
            <button type="button" class="ew-editor-btn" id="ew-add-text">Text hinzufügen</button>

            <label class="ew-editor-btn ew-editor-upload" for="ew-image-upload">
              Bild hinzufügen
            </label>
            <input class="ew-editor-file" id="ew-image-upload" type="file" accept="image/png,image/jpeg" />            <div class="ew-editor-text-toolbar" id="ew-text-style-panel" aria-hidden="true">
              <span class="ew-editor-toolbar-label">Aa</span>
              <button type="button" class="ew-editor-grid-toggle ew-active" id="ew-toggle-grid" aria-pressed="true">Hilfslinien</button>

              <div class="ew-editor-style-controls">
                <select class="ew-editor-style-control" id="ew-font-family" aria-label="Schriftart">
                  <option value="Arial, sans-serif">Arial</option>
                  <option value="Georgia, serif">Georgia</option>
                  <option value="'Times New Roman', serif">Times New Roman</option>
                  <option value="Verdana, sans-serif">Verdana</option>
                  <option value="'Courier New', monospace">Courier New</option>
                </select>

                <input class="ew-editor-style-control" id="ew-font-size" type="number" min="4" max="80" step="1" value="20" aria-label="Schriftgröße" />

                <div class="ew-editor-color-dropdown">
                  <button type="button" class="ew-editor-color-toggle" id="ew-color-menu-toggle" aria-label="Schriftfarbe wählen" aria-expanded="false">
                    <span class="ew-editor-color-preview" id="ew-color-preview"></span>
                  </button>

                  <div class="ew-editor-color-menu" id="ew-color-menu" hidden>
                    <div class="ew-editor-color-palette" aria-label="Schriftfarbe">
                      <button type="button" class="ew-editor-color-swatch ew-active" data-color="#000000" aria-label="Schwarz"></button>
                      <button type="button" class="ew-editor-color-swatch ew-light" data-color="#ffffff" aria-label="Weiß"></button>
                      <button type="button" class="ew-editor-color-swatch" data-color="#ff0000" aria-label="Rot"></button>
                      <button type="button" class="ew-editor-color-swatch" data-color="#0000ff" aria-label="Blau"></button>
                      <button type="button" class="ew-editor-color-swatch" data-color="#008000" aria-label="Grün"></button>
                      <button type="button" class="ew-editor-color-swatch" data-color="#ffff00" aria-label="Gelb"></button>
                      <button type="button" class="ew-editor-color-swatch" data-color="#ff8bea" aria-label="Pink"></button>
                      <button type="button" class="ew-editor-color-swatch" data-color="#7b3ff2" aria-label="Lila"></button>
                      <button type="button" class="ew-editor-color-swatch" data-color="#ff8c00" aria-label="Orange"></button>
                      <button type="button" class="ew-editor-color-swatch" data-color="#8b4513" aria-label="Braun"></button>
                      <button type="button" class="ew-editor-color-swatch" data-color="#808080" aria-label="Grau"></button>
                      <button type="button" class="ew-editor-color-swatch" data-color="#1f1966" aria-label="Dunkelblau"></button>
                    </div>

                    <input class="ew-editor-style-control ew-editor-hex-input" id="ew-font-color" type="text" value="#000000" maxlength="7" aria-label="Farbcode" />
                  </div>
                </div>

                <div class="ew-editor-actions-group" aria-label="Textformatierung">
                  <div class="ew-editor-format-group" aria-label="Schriftstil">
                    <button type="button" class="ew-editor-format-btn" id="ew-font-bold" aria-pressed="false" aria-label="Fett"><strong>F</strong></button>
                    <button type="button" class="ew-editor-format-btn" id="ew-font-underline" aria-pressed="false" aria-label="Unterstrichen"><span class="ew-format-u">U</span></button>
                  </div>

                  <div class="ew-editor-align-group" aria-label="Schriftausrichtung">
                    <button type="button" class="ew-editor-align-btn" data-align="left">L</button>
                    <button type="button" class="ew-editor-align-btn" data-align="center">M</button>
                    <button type="button" class="ew-editor-align-btn" data-align="right">R</button>
                  </div>
                </div>
              </div>
            </div>

          </div>

          <div class="ew-editor-inside-view-label">Ansicht Innenseite</div>


          <div class="ew-editor-canvas-viewport" id="ew-editor-canvas-viewport">


            
            <button type="button" class="ew-editor-focus-toggle" id="ew-toggle-focus" aria-pressed="false" aria-label="Editierbaren Bereich vergrößern"><svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M9 3H3v6"/><path d="M3 3l7 7"/><path d="M15 21h6v-6"/><path d="M21 21l-7-7"/></svg></button>
<div class="ew-editor-canvas" id="ew-editor-canvas"></div>


          </div>
        </div>
      </div>
    </div>
  `;

  const canvas = root.querySelector('#ew-editor-canvas');
  const canvasViewport = root.querySelector('#ew-editor-canvas-viewport');

  const ewEditorBackgroundUrl = window.ewCardEditorInsidePreviewUrl || '';

  if (ewEditorBackgroundUrl) {
    root.style.setProperty('--ew-editor-bg-image', `url("${ewEditorBackgroundUrl}")`);
    canvas.style.setProperty('--ew-editor-bg-image', `url("${ewEditorBackgroundUrl}")`);
  }
  const addTextButton = root.querySelector('#ew-add-text');
  const imageUpload = root.querySelector('#ew-image-upload');
  const fontFamilySelect = root.querySelector('#ew-font-family');
  const fontSizeInput = root.querySelector('#ew-font-size');
  const fontColorInput = root.querySelector('#ew-font-color');
  const colorToggleButton = root.querySelector('#ew-color-menu-toggle');
  const colorMenu = root.querySelector('#ew-color-menu');
  const colorPreview = root.querySelector('#ew-color-preview');
  const colorSwatches = Array.from(root.querySelectorAll('.ew-editor-color-swatch'));
  const alignButtons = Array.from(root.querySelectorAll('.ew-editor-align-btn'));
  const boldButton = root.querySelector('#ew-font-bold');
  const underlineButton = root.querySelector('#ew-font-underline');
  const formatButtons = [boldButton, underlineButton].filter(Boolean);

  const ewAlignIcons = {
    left: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 6h16"/><path d="M4 11h12"/><path d="M4 16h16"/></svg>',
    center: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 6h16"/><path d="M7 11h10"/><path d="M4 16h16"/></svg>',
    right: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 6h16"/><path d="M8 11h12"/><path d="M4 16h16"/></svg>'
  };

  alignButtons.forEach((button) => {
    const align = button.dataset.align || 'left';
    if (ewAlignIcons[align]) {
      button.innerHTML = ewAlignIcons[align];
      button.setAttribute(
        'aria-label',
        align === 'left' ? 'Linksbündig' : align === 'center' ? 'Zentriert' : 'Rechtsbündig'
      );
    }
  });

  const stylePanel = root.querySelector('#ew-text-style-panel');
  const gridToggleButton = root.querySelector('#ew-toggle-grid');
  const focusToggleButton = root.querySelector('#ew-toggle-focus');

  let focusTogglePlaceholder = null;

  if (focusToggleButton && focusToggleButton.parentNode) {
    focusTogglePlaceholder = document.createComment('EW focus toggle original position');
    focusToggleButton.parentNode.insertBefore(focusTogglePlaceholder, focusToggleButton);
  }

function getPersonalizationPanel() {
  return (
    root.closest('[id^="ewPersonalizationCanvas-"]') ||
    root.closest('.offcanvas') ||
    null
  );
}

function getFocusToggleFloatingLayer() {
  return getPersonalizationPanel() || canvasViewport || document.body;
}

function updateFloatingFocusTogglePosition() {
  if (!focusToggleButton) return;
  if (focusToggleButton.dataset.ewFloatingFocusToggle !== 'true') return;

  const panel = getPersonalizationPanel();
  const layer = getFocusToggleFloatingLayer();

  if (!canvasViewport || !layer) return;

  const referenceRect = canvasViewport.getBoundingClientRect();
  const layerRect = panel
    ? panel.getBoundingClientRect()
    : {
        top: 0,
        left: 0,
        width: window.innerWidth,
        height: window.innerHeight
      };

  const buttonSize = focusToggleButton.offsetWidth || 46;
  const edgeGap = 4;
  const safeGap = 8;

  /*
    Position wie der ursprüngliche Zoom-In-Button:
    rechts oben am Canvas-Viewport, nicht rechts oben am gesamten Screen.
  */
  let top = referenceRect.top - layerRect.top + edgeGap;
  let left = referenceRect.right - layerRect.left - buttonSize - edgeGap;

  /*
    Nicht über den Offcanvas-Schließen-Button legen.
  */
  const closeButton = panel?.querySelector(
    '.btn-close, [data-bs-dismiss="offcanvas"], [aria-label="Close"], [aria-label="Schließen"]'
  );

  if (closeButton) {
    const closeRect = closeButton.getBoundingClientRect();

    const buttonRect = {
      top,
      right: left + buttonSize,
      bottom: top + buttonSize,
      left
    };

    const closeLocalRect = {
      top: closeRect.top - layerRect.top,
      right: closeRect.right - layerRect.left,
      bottom: closeRect.bottom - layerRect.top,
      left: closeRect.left - layerRect.left
    };

    const overlapsCloseButton =
      buttonRect.left < closeLocalRect.right &&
      buttonRect.right > closeLocalRect.left &&
      buttonRect.top < closeLocalRect.bottom &&
      buttonRect.bottom > closeLocalRect.top;

    if (overlapsCloseButton) {
      top = closeLocalRect.bottom + 10;
    }
  }

  top = Math.max(safeGap, Math.min(top, layerRect.height - buttonSize - safeGap));
  left = Math.max(safeGap, Math.min(left, layerRect.width - buttonSize - safeGap));

  focusToggleButton.style.setProperty(
    '--ew-focus-toggle-floating-top',
    `${Math.round(top)}px`
  );

  focusToggleButton.style.setProperty(
    '--ew-focus-toggle-floating-left',
    `${Math.round(left)}px`
  );
}

function moveFocusToggleToFloatingLayer() {
  if (!focusToggleButton) return;
  if (!isMobileViewport()) return;
  if (focusToggleButton.dataset.ewFloatingFocusToggle === 'true') {
    updateFloatingFocusTogglePosition();
    return;
  }

  const layer = getFocusToggleFloatingLayer();

  focusToggleButton.dataset.ewFloatingFocusToggle = 'true';
  focusToggleButton.classList.add('ew-focus-toggle-floating');

  /*
    Wichtig: nicht document.body.
    Der Button bleibt innerhalb der Personalisierungsmaske,
    damit kein Outside-/Close-Klick ausgelöst wird.
  */
  layer.appendChild(focusToggleButton);

  requestAnimationFrame(updateFloatingFocusTogglePosition);
}

function restoreFocusToggleFromFloatingLayer() {
  if (!focusToggleButton) return;
  if (focusToggleButton.dataset.ewFloatingFocusToggle !== 'true') return;

  focusToggleButton.classList.remove('ew-focus-toggle-floating');
  delete focusToggleButton.dataset.ewFloatingFocusToggle;

  focusToggleButton.style.removeProperty('--ew-focus-toggle-floating-top');
  focusToggleButton.style.removeProperty('--ew-focus-toggle-floating-left');

  if (focusTogglePlaceholder && focusTogglePlaceholder.parentNode) {
    focusTogglePlaceholder.parentNode.insertBefore(
      focusToggleButton,
      focusTogglePlaceholder.nextSibling
    );
  } else if (canvasViewport) {
    canvasViewport.insertBefore(focusToggleButton, canvasViewport.firstChild);
  }
}

function updateFocusToggleLayerForMode(enabled) {
  if (enabled && isMobileViewport()) {
    moveFocusToggleToFloatingLayer();
    return;
  }

  restoreFocusToggleFromFloatingLayer();
}

  function resolveProductForm(editorRoot) {
    const directForm = editorRoot.closest("form[action*='/cart/add']");
    if (directForm) return directForm;

    let scope = editorRoot.parentElement;
    while (scope && scope !== document.body) {
      const scopedForm = scope.querySelector("form[action*='/cart/add']");
      if (scopedForm) return scopedForm;
      scope = scope.parentElement;
    }

    return document.querySelector("form[action*='/cart/add']");
  }

  let productForm = null;
  let boundProductForm = null;

  function bindEditorApiToForm(form) {
    if (!form || form === boundProductForm) return;

    form.ewSyncOutputs = syncOutputs;
    form.ewGeneratePrintableImage = generatePrintableImage;
    form.ewEditorRoot = root;
    form.ewRestoreDesign = restoreDesignFromConfig;
    form.ewGetPersonalizationPayload = async () => {
      await syncOutputs();

      return {
        designId: getDesignIdInput()?.value || '',
        designConfig: '',
        previewImage: ''
      };
    };

    boundProductForm = form;
  }

  function getProductForm() {
    if (!productForm || !document.body.contains(productForm)) {
      productForm = resolveProductForm(root);
    }

    if (productForm) {
      bindEditorApiToForm(productForm);
    }

    return productForm;
  }

  function ensureInputInProductForm(inputName) {
    const currentForm = getProductForm();
    if (!currentForm) {
      console.warn('EW Editor: Kein Produktformular gefunden für', inputName, root);
      return null;
    }

    let input = currentForm.querySelector(`[name="${inputName}"]`);
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = inputName;
      currentForm.appendChild(input);
    }
    return input;
  }

  function getDesignConfigInput() {
    return ensureInputInProductForm('properties[_design_config]');
  }

  function getPreviewInput() {
    return ensureInputInProductForm('properties[_preview_image]');
  }

  function getDesignIdInput() {
    return ensureInputInProductForm('properties[_ew_design_id]');
  }

  async function savePersonalizationDesign(designConfig, previewImage, shippingType = '') {
  const response = await fetch('/apps/everywish-personalization/personalization-design', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      designConfig,
      previewImage,
      shippingType,
    }),
  });

  const json = await response.json();

  if (!response.ok || !json?.success || !json?.designId) {
    throw new Error(json?.error || 'Personalization design save failed');
  }

  return json.designId;
}

  const EW_IMAGE_STORE_KEY = 'ew-editor-image-store';

  function readEwImageStore() {
    try {
      return JSON.parse(sessionStorage.getItem(EW_IMAGE_STORE_KEY) || '{}');
    } catch (error) {
      return {};
    }
  }

  function writeEwImageStore(store) {
    try {
      sessionStorage.setItem(EW_IMAGE_STORE_KEY, JSON.stringify(store));
    } catch (error) {
      console.warn('EW Editor: image store konnte nicht gespeichert werden', error);
    }
  }

  function saveImageSource(imageId, src) {
    if (!imageId || !src) return;
    const store = readEwImageStore();
    store[imageId] = src;
    writeEwImageStore(store);
  }

  function getImageSource(imageId) {
    if (!imageId) return '';
    const store = readEwImageStore();
    return store[imageId] || '';
  }

  function getAddToCartButtons() {
    const form = getProductForm();
    if (!form) return [];

    return Array.from(
      form.querySelectorAll('button, input[type="submit"], input[type="button"]')
    ).filter((button) => {
      if (button.classList && button.classList.contains('ew-editor-btn')) return false;
      if (button.id === 'ew-add-text' || button.id === 'ew-generate-preview') return false;

      if (
        button.id &&
        (
          button.id.startsWith('ew-open-personalization-') ||
          button.id.startsWith('ew-apply-personalization-')
        )
      ) {
        return false;
      }

      const type = (button.getAttribute('type') || '').toLowerCase();
      const name = (button.getAttribute('name') || '').toLowerCase();

      return (
        type === 'submit' ||
        name === 'add' ||
        button.classList.contains('product-form__submit') ||
        button.hasAttribute('data-add-to-cart')
      );
    });
  }

  function setAddToCartButtonsDisabled(disabled) {
    getAddToCartButtons().forEach((button) => {
      if (disabled) {
        button.dataset.ewDisabledByEditor = 'true';
        button.disabled = true;
      } else if (button.dataset.ewDisabledByEditor === 'true') {
        button.disabled = false;
        delete button.dataset.ewDisabledByEditor;
      }
    });
  }

  const maxTextCount = 2;
  let textCount = 0;
  let imageCount = 0;
  let selectedElement = null;
  let currentLayerIndex = 1;
  let suppressNextCanvasDeselect = false;

  const EW_CARD_SPEC = {
    fullWidthMm: 220,
    fullHeightMm: 153.5,
    editableLeftMm: 112.5,
    editableTopMm: 2.5,
    editableWidthMm: 105,
    editableHeightMm: 148.5
  };

  const EW_MOBILE_FOCUS_SCALE = EW_CARD_SPEC.fullWidthMm / EW_CARD_SPEC.editableWidthMm;
  let editorFocusScale = EW_MOBILE_FOCUS_SCALE;

  function isMobileViewport() {
    return window.matchMedia
      ? window.matchMedia('(max-width: 767px)').matches
      : window.innerWidth <= 767;
  }

  function isMobileEditorFocusMode() {
    return !!(
      canvasViewport &&
      canvasViewport.classList.contains('ew-focus-right') &&
      isMobileViewport()
    );
  }

  function getEditorInteractionScale() {
    return isMobileEditorFocusMode() ? editorFocusScale : 1;
  }

  function getCanvasLayoutRect() {
    return {
      width: canvas.offsetWidth || canvas.clientWidth || canvas.getBoundingClientRect().width || 0,
      height: canvas.offsetHeight || canvas.clientHeight || canvas.getBoundingClientRect().height || 0
    };
  }


  function updateEditorFocusTransform() {
    if (!canvas || !canvasViewport) return;

    if (!isMobileEditorFocusMode()) {
      editorFocusScale = 1;
      canvas.style.removeProperty('left');
      canvas.style.removeProperty('top');
      canvas.style.removeProperty('margin');
      canvas.style.removeProperty('transform');
      canvas.style.removeProperty('transform-origin');
      return;
    }

    const bounds = getEditableBounds();
    const snapCenter = getEditableCenter();
    const viewportRect = canvasViewport.getBoundingClientRect();

    if (!bounds.width || !bounds.height || !viewportRect.width || !viewportRect.height) return;

    const viewportAspect = viewportRect.width / viewportRect.height;

    // Kleiner als 1 = stärkerer Zoom um die echte Snap-Mitte.
    // Wichtig: Mittelpunkt bleibt exakt getEditableCenter().
    const focusCoverage = 0.82;

    let focusWidth = bounds.width * focusCoverage;
    let focusHeight = focusWidth / viewportAspect;

    if (focusHeight > bounds.height * focusCoverage) {
      focusHeight = bounds.height * focusCoverage;
      focusWidth = focusHeight * viewportAspect;
    }

    let focusLeft = snapCenter.x - (focusWidth / 2);
    let focusTop = snapCenter.y - (focusHeight / 2);

    focusLeft = Math.max(bounds.left, Math.min(focusLeft, bounds.left + bounds.width - focusWidth));
    focusTop = Math.max(bounds.top, Math.min(focusTop, bounds.top + bounds.height - focusHeight));

    const scale = viewportRect.width / focusWidth;
    editorFocusScale = scale;

    canvas.style.setProperty('left', '0', 'important');
    canvas.style.setProperty('top', '0', 'important');
    canvas.style.setProperty('margin', '0', 'important');
    canvas.style.setProperty('transform-origin', '0 0', 'important');
    canvas.style.setProperty(
      'transform',
      `matrix(${scale}, 0, 0, ${scale}, ${-focusLeft * scale}, ${-focusTop * scale})`,
      'important'
    );
  }

  function clampAllItemsToEditableArea() {
    canvas.querySelectorAll('.ew-editor-item').forEach((item) => {
      let x = parseFloat(item.getAttribute('data-x')) || 0;
      let y = parseFloat(item.getAttribute('data-y')) || 0;

      const clamped = clampItemToEditableArea(item, x, y);
      x = roundEditorValue(clamped.x);
      y = roundEditorValue(clamped.y);

      item.setAttribute('data-x', String(x));
      item.setAttribute('data-y', String(y));
      item.style.transform = `translate(${x}px, ${y}px)`;
    });

    updateDesignConfig();
  }

  function setEditorFocusMode(enabled) {
    if (!canvasViewport || !focusToggleButton) return;

    const shouldEnable = !!enabled && isMobileViewport();

    if (!shouldEnable) {
      blurActiveEditorTextContent();
    }

    const expandIcon = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M9 3H3v6"/><path d="M3 3l7 7"/><path d="M15 21h6v-6"/><path d="M21 21l-7-7"/></svg>';
    const collapseIcon = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M3 9h6V3"/><path d="M10 10L3 3"/><path d="M21 15h-6v6"/><path d="M14 14l7 7"/></svg>';

    canvasViewport.classList.toggle('ew-focus-right', shouldEnable);
    focusToggleButton.classList.toggle('ew-active', shouldEnable);
    focusToggleButton.setAttribute('aria-pressed', shouldEnable ? 'true' : 'false');
    focusToggleButton.setAttribute(
      'aria-label',
      shouldEnable ? 'Ganze Karte anzeigen' : 'Editierbaren Bereich vergrößern'
    );
    focusToggleButton.innerHTML = shouldEnable ? collapseIcon : expandIcon;

    updateFocusToggleLayerForMode(shouldEnable);

    requestAnimationFrame(() => {
      refreshMobileSafeTextRendering();
      updateEditorFocusTransform();
      updateFloatingFocusTogglePosition();
      reapplyAllSnapStates();
    });
  }

  function getEditableBounds() {
    const width = canvas.clientWidth || canvas.getBoundingClientRect().width || 0;
    const height = canvas.clientHeight || canvas.getBoundingClientRect().height || 0;

    return {
      left: width * (EW_CARD_SPEC.editableLeftMm / EW_CARD_SPEC.fullWidthMm),
      top: height * (EW_CARD_SPEC.editableTopMm / EW_CARD_SPEC.fullHeightMm),
      width: width * (EW_CARD_SPEC.editableWidthMm / EW_CARD_SPEC.fullWidthMm),
      height: height * (EW_CARD_SPEC.editableHeightMm / EW_CARD_SPEC.fullHeightMm)
    };
  }

  function clampItemToEditableArea(target, x, y, width = target.offsetWidth, height = target.offsetHeight) {
    const bounds = getEditableBounds();
    const maxX = bounds.left + bounds.width - width;
    const maxY = bounds.top + bounds.height - height;

    return {
      x: Math.max(bounds.left, Math.min(x, maxX)),
      y: Math.max(bounds.top, Math.min(y, maxY))
    };
  }

  function roundEditorValue(value) {
    return Math.round(Number(value || 0) * 1000) / 1000;
  }

  function getEditableCenter() {
    const bounds = getEditableBounds();

    return {
      x: bounds.left + (bounds.width / 2),
      y: bounds.top + (bounds.height / 2)
    };
  }

  function updateCenterGuides() {
    // Center guides are rendered via CSS/static guide only.
  }

  function getDefaultItemPosition(width, height) {
    const center = getEditableCenter();

    return {
      x: roundEditorValue(center.x - (width / 2)),
      y: roundEditorValue(center.y - (height / 2))
    };
  }

  function bringElementToFront(el) {
    if (!el) return;
    currentLayerIndex += 1;
    el.style.zIndex = String(currentLayerIndex);
    el.setAttribute('data-layer', String(currentLayerIndex));
  }

  let pendingAssetLoads = 0;
  let pendingAssetResolvers = [];

  function markAssetPending() {
    pendingAssetLoads += 1;
  }

  function markAssetReady() {
    pendingAssetLoads = Math.max(0, pendingAssetLoads - 1);

    if (pendingAssetLoads === 0 && pendingAssetResolvers.length) {
      const resolvers = [...pendingAssetResolvers];
      pendingAssetResolvers = [];
      resolvers.forEach((resolve) => resolve());
    }
  }

  function waitForPendingAssets() {
    if (pendingAssetLoads === 0) return Promise.resolve();

    return new Promise((resolve) => {
      pendingAssetResolvers.push(resolve);
    });
  }

  function waitForCanvasImages() {
    const images = Array.from(canvas.querySelectorAll('.ew-editor-image img'));

    const pendingImages = images.filter((img) => {
      return !img.complete || img.naturalWidth === 0;
    });

    if (!pendingImages.length) {
      return Promise.resolve();
    }

    return Promise.all(
      pendingImages.map((img) => {
        return new Promise((resolve) => {
          const done = () => resolve();
          img.addEventListener('load', done, { once: true });
          img.addEventListener('error', done, { once: true });
        });
      })
    );
  }

  function waitForNextPaint() {
    return new Promise((resolve) => {
      requestAnimationFrame(() => {
        requestAnimationFrame(resolve);
      });
    });
  }


  function updateCanvasHasItemsState() {
    if (!canvas) return;
    canvas.classList.toggle('ew-has-items', !!canvas.querySelector('.ew-editor-item'));
  }

  const ewCanvasItemObserver = new MutationObserver(updateCanvasHasItemsState);
  ewCanvasItemObserver.observe(canvas, { childList: true });
  updateCanvasHasItemsState();

  function selectElement(el) {
    canvas.querySelectorAll('.ew-editor-item').forEach((item) => {
      item.classList.remove('ew-selected');
    });

    selectedElement = el;

    if (el) {
      bringElementToFront(el);
      el.classList.add('ew-selected');
    }

    updateStyleControlsFromElement(el);
  }

  function removeEditorItem(elementToDelete) {
    if (!elementToDelete) return;

    if (elementToDelete.classList.contains('ew-editor-text')) {
      textCount = Math.max(0, textCount - 1);
      addTextButton.disabled = textCount >= maxTextCount;
    }

    if (elementToDelete.classList.contains('ew-editor-image')) {
      imageCount = Math.max(0, imageCount - 1);
    }

    if (selectedElement === elementToDelete) {
      selectedElement = null;
    }

    elementToDelete.remove();
    updateStyleControlsFromElement(null);
    syncOutputs({ generatePreview: false });
  }

  function createResizeHandle(wrapper) {
    const handle = document.createElement('div');
    handle.className = 'ew-resize-handle';
    wrapper.appendChild(handle);

    const deleteHandle = document.createElement('button');
    deleteHandle.type = 'button';
    deleteHandle.className = 'ew-delete-handle';
    deleteHandle.setAttribute('aria-label', 'Auswahl entfernen');
    deleteHandle.title = 'Auswahl entfernen';
    deleteHandle.textContent = '×';

    deleteHandle.addEventListener('mousedown', (event) => {
      event.preventDefault();
      event.stopPropagation();
      removeEditorItem(wrapper);
    });

    deleteHandle.addEventListener('touchstart', (event) => {
      event.preventDefault();
      event.stopPropagation();
      removeEditorItem(wrapper);
    }, { passive: false });

    deleteHandle.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
    });

    wrapper.appendChild(deleteHandle);
  }

  function normalizeColorToHex(color) {
    if (!color) return '#000000';
    if (color.startsWith('#')) return color;

    const match = color.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)/);
    if (!match) return '#000000';

    return '#' + [match[1], match[2], match[3]]
      .map((value) => Number(value).toString(16).padStart(2, '0'))
      .join('');
  }

  function getTextContentElement(el) {
    return el?.classList?.contains('ew-editor-text')
      ? el.querySelector('.ew-editor-text-content')
      : null;
  }

  const EW_MOBILE_TEXT_FOCUS_SAFE_FONT_SIZE = 16;

function getEditorTextFontSize(content) {
  if (!content) return 20;

  const stored = parseFloat(content.dataset.ewEditorFontSize || '');
  if (Number.isFinite(stored) && stored > 0) {
    return stored;
  }

  const inline = parseFloat(content.style.fontSize || '');
  if (Number.isFinite(inline) && inline > 0) {
    return inline;
  }

  const computed = parseFloat(getComputedStyle(content).fontSize || '');
  return Number.isFinite(computed) && computed > 0 ? computed : 20;
}

function applyMobileSafeTextRendering(content) {
  if (!content) return;

  const realFontSize = getEditorTextFontSize(content);
  const shouldUseSafeMobileRendering =
    isMobileViewport() && realFontSize < EW_MOBILE_TEXT_FOCUS_SAFE_FONT_SIZE;

  content.dataset.ewEditorFontSize = String(roundEditorValue(realFontSize));
  content.style.webkitTextSizeAdjust = '100%';
  content.style.textSizeAdjust = '100%';

  if (shouldUseSafeMobileRendering) {
    const scale = Math.max(0.1, realFontSize / EW_MOBILE_TEXT_FOCUS_SAFE_FONT_SIZE);
    const inverseScalePercent = 100 / scale;

    /*
      iOS/Safari sieht 16px und zoomt deshalb beim Fokus nicht.
      Optisch wird der Text wieder auf die echte Editor-Schriftgröße skaliert.
    */
    content.style.fontSize = `${EW_MOBILE_TEXT_FOCUS_SAFE_FONT_SIZE}px`;
    content.style.transformOrigin = '0 0';
    content.style.transform = `scale(${roundEditorValue(scale)})`;
    content.style.width = `${roundEditorValue(inverseScalePercent)}%`;
    content.style.height = `${roundEditorValue(inverseScalePercent)}%`;
    content.style.flex = `0 0 ${roundEditorValue(inverseScalePercent)}%`;
    content.style.maxWidth = 'none';
    content.style.maxHeight = 'none';
    content.dataset.ewMobileSafeTextRendering = 'true';

    return;
  }

  content.style.fontSize = `${realFontSize}px`;
  content.style.removeProperty('transform');
  content.style.removeProperty('transform-origin');
  content.style.width = '100%';
  content.style.height = '100%';
  content.style.flex = '1 1 auto';
  content.style.removeProperty('max-width');
  content.style.removeProperty('max-height');
  delete content.dataset.ewMobileSafeTextRendering;
}

function setEditorTextFontSize(content, fontSize) {
  if (!content) return;

  const normalizedFontSize = Math.max(1, Number(fontSize) || 20);

  content.dataset.ewEditorFontSize = String(roundEditorValue(normalizedFontSize));
  applyMobileSafeTextRendering(content);
}

function refreshMobileSafeTextRendering() {
  if (!canvas) return;

  canvas.querySelectorAll('.ew-editor-text-content').forEach((content) => {
    applyMobileSafeTextRendering(content);
  });
}

function prepareMobileTextFieldBeforeFocus(event) {
  if (!isMobileViewport()) return;

  let target = event.target;

  if (target && target.nodeType === Node.TEXT_NODE) {
    target = target.parentElement;
  }

  if (!(target instanceof Element)) return;

  const content = target.closest('.ew-editor-text-content');

  if (!content || !canvas.contains(content)) return;

  /*
    Wichtig: vor dem eigentlichen Fokus anwenden,
    damit iOS/Safari gar nicht erst nativ hineinzoomt.
  */
  applyMobileSafeTextRendering(content);
}

function blurActiveEditorTextContent() {
  const active = document.activeElement;

  if (
    active &&
    canvas.contains(active) &&
    active.classList &&
    active.classList.contains('ew-editor-text-content') &&
    typeof active.blur === 'function'
  ) {
    active.blur();
  }
}

function removeMobileSafeTextRenderingInContainer(container) {
  if (!container) return;

  container.querySelectorAll('.ew-editor-text-content').forEach((content) => {
    const realFontSize = getEditorTextFontSize(content);

    content.style.fontSize = `${realFontSize}px`;
    content.style.removeProperty('transform');
    content.style.removeProperty('transform-origin');
    content.style.width = '100%';
    content.style.height = '100%';
    content.style.flex = '1 1 auto';
    content.style.removeProperty('max-width');
    content.style.removeProperty('max-height');
    delete content.dataset.ewMobileSafeTextRendering;
  });
}


  function normalizeFontFamilyValue(value) {
    return String(value || '')
      .replace(/["']/g, '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  function setFontFamilySelectValue(value) {
    if (!fontFamilySelect) return;

    const wanted = normalizeFontFamilyValue(value);
    const match = Array.from(fontFamilySelect.options).find((option) => {
      return normalizeFontFamilyValue(option.value) === wanted;
    });

    fontFamilySelect.value = match ? match.value : 'Arial, sans-serif';
  }

  function updateStyleControlsFromElement(el) {
    const content = getTextContentElement(el);
    const isText = !!content;

    if (stylePanel) {
      const hasSelection = !!el;
      stylePanel.classList.toggle('ew-visible', hasSelection);
      stylePanel.setAttribute('aria-hidden', hasSelection ? 'false' : 'true');
    }

    [fontFamilySelect, fontSizeInput, fontColorInput, colorToggleButton, ...colorSwatches, ...formatButtons, ...alignButtons].forEach((control) => {
      if (control) control.disabled = !isText;
    });

    if (!isText) return;

    const styles = getComputedStyle(content);
    const fontFamily = content.style.fontFamily || styles.fontFamily || 'Arial, sans-serif';
    const fontSize = Math.round(getEditorTextFontSize(content));
    const color = normalizeColorToHex(content.style.color || styles.color || '#000000');
    const textAlign = content.style.textAlign || styles.textAlign || 'left';
    const fontWeight = content.style.fontWeight || styles.fontWeight || '400';
    const textDecorationLine = content.style.textDecorationLine || styles.textDecorationLine || '';
    const isBold = fontWeight === 'bold' || parseInt(fontWeight, 10) >= 600;
    const isUnderline = String(textDecorationLine).includes('underline');

    setFontFamilySelectValue(fontFamily);
    if (fontSizeInput) fontSizeInput.value = String(fontSize || 20);
    if (fontColorInput) fontColorInput.value = color;
    if (colorPreview) colorPreview.style.backgroundColor = color;

    colorSwatches.forEach((button) => {
      button.classList.toggle('ew-active', button.dataset.color?.toLowerCase() === color.toLowerCase());
    });

    if (boldButton) {
      boldButton.classList.toggle('ew-active', isBold);
      boldButton.setAttribute('aria-pressed', isBold ? 'true' : 'false');
    }

    if (underlineButton) {
      underlineButton.classList.toggle('ew-active', isUnderline);
      underlineButton.setAttribute('aria-pressed', isUnderline ? 'true' : 'false');
    }

    alignButtons.forEach((button) => {
      button.classList.toggle('ew-active', button.dataset.align === textAlign);
    });
  }

  function applyTextStyle(updates = {}) {
    const content = getTextContentElement(selectedElement);
    if (!content) return;

    if (updates.fontFamily) content.style.fontFamily = updates.fontFamily;

    if ('fontSize' in updates) {
      setEditorTextFontSize(content, updates.fontSize);
    }

    if (updates.color) content.style.color = updates.color;
    if (updates.textAlign) content.style.textAlign = updates.textAlign;
    if ('fontWeight' in updates) content.style.fontWeight = updates.fontWeight;
    if ('textDecorationLine' in updates) content.style.textDecorationLine = updates.textDecorationLine;

    updateStyleControlsFromElement(selectedElement);
    syncOutputs({ generatePreview: false });
  }

  function getCleanTextFromEditorItem(el) {
    const content = el.querySelector('.ew-editor-text-content');
    if (!content) return '';

    // Platzhalter darf nie als echter Text gespeichert werden.
    if (content.dataset.ewPlaceholder === 'true') {
      return '';
    }

    return (content.innerText || content.textContent || '')
      .replace(/\u200B/g, '')
      .trim();
  }

  function clearPlaceholderTextInContainer(container, options = {}) {
    const { markAsRealEmpty = false } = options;

    if (!container) return;

    container
      .querySelectorAll('.ew-editor-text-content[data-ew-placeholder="true"]')
      .forEach((content) => {
        content.textContent = '';

        if (markAsRealEmpty) {
          content.dataset.ewPlaceholder = 'false';
        }
      });
  }


  function getEditorImageSource(img) {
    if (!img) return '';
    return img.currentSrc || img.src || '';
  }

  function getDesignData() {
    const elements = [];

    canvas.querySelectorAll('.ew-editor-item').forEach((el) => {
      const x = parseFloat(el.getAttribute('data-x')) || 0;
      const y = parseFloat(el.getAttribute('data-y')) || 0;
      const width = el.offsetWidth;
      const height = el.offsetHeight;
      const layer = parseInt(el.getAttribute('data-layer') || '1', 10) || 1;

      if (el.classList.contains('ew-editor-text')) {
        const content = el.querySelector('.ew-editor-text-content');

        elements.push({
          type: 'text',
          x,
          y,
          width,
          height,
          layer,
          text: getCleanTextFromEditorItem(el),
          fontFamily: content?.style.fontFamily || 'Arial, sans-serif',
          fontSize: Math.round(getEditorTextFontSize(content)),
          color: normalizeColorToHex(content?.style.color || '#000000'),
          textAlign: content?.style.textAlign || 'left',
          fontWeight: content?.style.fontWeight || '400',
          textDecorationLine: content?.style.textDecorationLine || 'none'
        });
      }

      if (el.classList.contains('ew-editor-image')) {
        const img = el.querySelector('img');

        elements.push({
          type: 'image',
          x,
          y,
          width,
          height,
          layer,
          imageId: el.getAttribute('data-image-id') || '',
          previewSrc: getEditorImageSource(img),
          originalWidth: Number(el.dataset.ewOriginalWidth || img?.naturalWidth || 0),
          originalHeight: Number(el.dataset.ewOriginalHeight || img?.naturalHeight || 0)
        });
      }
    });

    return elements;
  }

  function updateDesignConfig() {
    const designConfigInput = getDesignConfigInput();
    if (!designConfigInput) return;

    const cleaned = getDesignData().map((item) => {
      if (item.type === 'image') {
        return {
          type: item.type,
          x: item.x,
          y: item.y,
          width: item.width,
          height: item.height,
          layer: item.layer,
          imageId: item.imageId,
          previewSrc: item.previewSrc || '',
          originalWidth: item.originalWidth || 0,
          originalHeight: item.originalHeight || 0
        };
      }

      if (item.type === 'text') {
        return {
          type: item.type,
          x: item.x,
          y: item.y,
          width: item.width,
          height: item.height,
          layer: item.layer,
          text: item.text || '',
          fontFamily: item.fontFamily || 'Arial, sans-serif',
          fontSize: item.fontSize || 20,
          color: item.color || '#000000',
          textAlign: item.textAlign || 'left',
          fontWeight: item.fontWeight || '400',
          textDecorationLine: item.textDecorationLine || 'none'
        };
      }

      return item;
    });

    designConfigInput.value = JSON.stringify(cleaned);
  }

  async function generatePreviewImage() {
    const previewInput = getPreviewInput();
    if (!previewInput) return '';

    const personalizationOffcanvas = root.closest('.offcanvas');
    const offcanvasIsHidden =
      personalizationOffcanvas &&
      (!personalizationOffcanvas.classList.contains('show') ||
        getComputedStyle(personalizationOffcanvas).visibility === 'hidden');

    if (offcanvasIsHidden) {
      return previewInput.value || '';
    }

    if (typeof html2canvas === 'undefined') {
      previewInput.value = '';
      return '';
    }

    const previewClone = canvas.cloneNode(true);
    previewClone.classList.add('ew-grid-hidden', 'ew-export-mode');
    clearPlaceholderTextInContainer(previewClone);
    removeMobileSafeTextRenderingInContainer(previewClone);

    if (window.ewCardEditorInsidePreviewUrl) {
      previewClone.style.setProperty(
        '--ew-editor-bg-image',
        `url("${window.ewCardEditorInsidePreviewUrl}")`
      );
    }
    const canvasRect = getCanvasLayoutRect();

    previewClone.style.width = `${canvasRect.width}px`;
    previewClone.style.height = `${canvasRect.height}px`;
    previewClone.style.minWidth = `${canvasRect.width}px`;
    previewClone.style.maxWidth = `${canvasRect.width}px`;
    previewClone.style.minHeight = `${canvasRect.height}px`;
    previewClone.style.maxHeight = `${canvasRect.height}px`;
    previewClone.style.overflow = 'hidden';
    previewClone.style.boxSizing = 'border-box';
    previewClone.style.position = 'fixed';
    previewClone.style.left = '-99999px';
    previewClone.style.top = '0';
    previewClone.style.pointerEvents = 'none';
    previewClone.style.zIndex = '-1';
    previewClone.style.transform = 'none';

    if (window.ewCardEditorInsidePreviewUrl) {
      const previewBackground = document.createElement('img');
      previewBackground.crossOrigin = 'anonymous';
      previewBackground.src = window.ewCardEditorInsidePreviewUrl;
      previewBackground.alt = '';
      previewBackground.style.position = 'absolute';
      previewBackground.style.inset = '0';
      previewBackground.style.width = '100%';
      previewBackground.style.height = '100%';
      previewBackground.style.objectFit = 'fill';
      previewBackground.style.display = 'block';
      previewBackground.style.pointerEvents = 'none';
      previewBackground.style.zIndex = '0';
      previewBackground.style.opacity = '1';

      previewClone.insertBefore(previewBackground, previewClone.firstChild);

      await new Promise((resolve) => {
        if (previewBackground.complete) {
          resolve();
          return;
        }

        previewBackground.onload = resolve;
        previewBackground.onerror = resolve;
      });
    }


    previewClone.querySelectorAll('.ew-resize-handle').forEach((el) => el.remove());

    previewClone.querySelectorAll('.ew-editor-item').forEach((el) => {
      el.classList.remove('ew-selected');
      el.style.outline = 'none';
    });

    previewClone.querySelectorAll('.ew-editor-text').forEach((el) => {
      el.style.border = 'none';
      el.style.background = 'transparent';
    });

    previewClone.querySelectorAll('.ew-editor-image').forEach((el) => {
      el.style.border = 'none';
    });

    const originalImages = canvas.querySelectorAll('.ew-editor-image img');
    const clonedImages = previewClone.querySelectorAll('.ew-editor-image img');

    clonedImages.forEach((img, index) => {
      const originalImg = originalImages[index];
      if (!originalImg) return;

      const styles = getComputedStyle(originalImg);

      img.style.width = styles.width;
      img.style.height = styles.height;
      img.style.minWidth = styles.width;
      img.style.maxWidth = styles.width;
      img.style.minHeight = styles.height;
      img.style.maxHeight = styles.height;
      img.style.objectFit = styles.objectFit;
      img.style.objectPosition = styles.objectPosition;
      img.style.display = styles.display;
      img.style.maxWidth = 'none';
    });

    document.body.appendChild(previewClone);

    try {
      await waitForNextPaint();

      const previewCanvas = await html2canvas(previewClone, {
        backgroundColor: '#ffffff',
        useCORS: true,
        logging: false
      });

      const dataUrl = previewCanvas.toDataURL('image/png');
      previewInput.value = '';
      return dataUrl;
    } catch (error) {
      console.error('EW preview generation failed', error);
      previewInput.value = '';
      return '';
    } finally {
      previewClone.remove();
    }
  }



  function waitForImagesInElement(container) {
    const images = Array.from(container.querySelectorAll('img'));
    const pendingImages = images.filter((img) => !img.complete || img.naturalWidth === 0);

    if (!pendingImages.length) return Promise.resolve();

    return Promise.all(
      pendingImages.map((img) => {
        return new Promise((resolve) => {
          const done = () => resolve();
          img.addEventListener('load', done, { once: true });
          img.addEventListener('error', done, { once: true });
        });
      })
    );
  }

  function renderImageForPrintExport(originalImg, editorWidth, editorHeight) {
    const sourceWidth = originalImg.naturalWidth || originalImg.width || 0;
    const sourceHeight = originalImg.naturalHeight || originalImg.height || 0;

    if (!sourceWidth || !sourceHeight || !editorWidth || !editorHeight) {
      return '';
    }

    const required = typeof getPrintRequirementForEditorSize === 'function'
      ? getPrintRequirementForEditorSize(editorWidth, editorHeight)
      : { widthPx: Math.ceil(editorWidth * 3), heightPx: Math.ceil(editorHeight * 3) };

    const outputWidth = Math.max(1, required.widthPx || Math.ceil(editorWidth * 3));
    const outputHeight = Math.max(1, required.heightPx || Math.ceil(editorHeight * 3));

    const outputCanvas = document.createElement('canvas');
    outputCanvas.width = outputWidth;
    outputCanvas.height = outputHeight;

    const ctx = outputCanvas.getContext('2d');
    if (!ctx) return '';

    ctx.imageSmoothingEnabled = true;
    ctx.imageSmoothingQuality = 'high';

    const sourceRatio = sourceWidth / sourceHeight;
    const targetRatio = outputWidth / outputHeight;

    let sx = 0;
    let sy = 0;
    let sw = sourceWidth;
    let sh = sourceHeight;

    // Match editor behaviour: cover the image box without distortion.
    if (sourceRatio > targetRatio) {
      sw = sourceHeight * targetRatio;
      sx = (sourceWidth - sw) / 2;
    } else {
      sh = sourceWidth / targetRatio;
      sy = (sourceHeight - sh) / 2;
    }

    ctx.drawImage(originalImg, sx, sy, sw, sh, 0, 0, outputWidth, outputHeight);

    try {
      return outputCanvas.toDataURL('image/png');
    } catch (error) {
      return '';
    }
  }

  async function normalizePrintCloneImages(printClone) {
    const originalItems = Array.from(canvas.querySelectorAll('.ew-editor-image'));
    const clonedItems = Array.from(printClone.querySelectorAll('.ew-editor-image'));

    clonedItems.forEach((clonedItem, index) => {
      const originalItem = originalItems[index];
      const originalImg = originalItem?.querySelector('img');
      const clonedImg = clonedItem.querySelector('img');

      if (!originalItem || !originalImg || !clonedImg) return;

      const editorWidth = originalItem.offsetWidth || clonedItem.offsetWidth || 0;
      const editorHeight = originalItem.offsetHeight || clonedItem.offsetHeight || 0;

      const renderedSrc = renderImageForPrintExport(originalImg, editorWidth, editorHeight);

      if (renderedSrc) {
        clonedImg.removeAttribute('srcset');
        clonedImg.src = renderedSrc;
        clonedImg.style.width = '100%';
        clonedImg.style.height = '100%';
        clonedImg.style.minWidth = '100%';
        clonedImg.style.maxWidth = '100%';
        clonedImg.style.minHeight = '100%';
        clonedImg.style.maxHeight = '100%';
        clonedImg.style.objectFit = 'fill';
        clonedImg.style.objectPosition = 'center center';
        clonedImg.style.display = 'block';
      }
    });

    await waitForImagesInElement(printClone);
  }

  async function generatePrintableImage() {
    if (typeof html2canvas === 'undefined') {
      return '';
    }

    await waitForPendingAssets();
    await waitForCanvasImages();
    await waitForNextPaint();

    const canvasRect = getCanvasLayoutRect();
    const editableBounds = getEditableBounds();

    // EW PRINT: final right-side print file at 200dpi.
    // 118mm x 171mm => approx. 929 x 1346 px.
    const printDpi = EW_PRINT_DPI;
    const printTargetWidthPx = Math.round((EW_PRINT_FORMAT_WIDTH_MM / 25.4) * printDpi);
    const printTargetHeightPx = Math.round((EW_PRINT_FORMAT_HEIGHT_MM / 25.4) * printDpi);
    const printScale = Math.min(
      printTargetWidthPx / editableBounds.width,
      printTargetHeightPx / editableBounds.height
    );

    const exportWrapper = document.createElement('div');
    exportWrapper.style.width = `${editableBounds.width}px`;
    exportWrapper.style.height = `${editableBounds.height}px`;
    exportWrapper.style.overflow = 'hidden';
    exportWrapper.style.background = '#ffffff';
    exportWrapper.style.boxSizing = 'border-box';
    exportWrapper.style.position = 'fixed';
    exportWrapper.style.left = '-99999px';
    exportWrapper.style.top = '0';
    exportWrapper.style.pointerEvents = 'none';
    exportWrapper.style.zIndex = '-1';
    exportWrapper.style.background = 'transparent';

    const printClone = canvas.cloneNode(true);
    printClone.classList.add('ew-grid-hidden', 'ew-export-mode');
    clearPlaceholderTextInContainer(printClone);
    removeMobileSafeTextRenderingInContainer(printClone);
    printClone.style.width = `${canvasRect.width}px`;
    printClone.style.height = `${canvasRect.height}px`;
    printClone.style.minWidth = `${canvasRect.width}px`;
    printClone.style.maxWidth = `${canvasRect.width}px`;
    printClone.style.minHeight = `${canvasRect.height}px`;
    printClone.style.maxHeight = `${canvasRect.height}px`;
    printClone.style.position = 'absolute';
    printClone.style.left = `${-editableBounds.left}px`;
    printClone.style.top = `${-editableBounds.top}px`;
    printClone.style.overflow = 'hidden';
    printClone.style.boxSizing = 'border-box';
    printClone.style.transform = 'none';

    printClone.querySelectorAll('.ew-resize-handle, .ew-delete-handle').forEach((el) => el.remove());

    printClone.querySelectorAll('.ew-editor-item').forEach((el) => {
      el.classList.remove('ew-selected');
      el.style.outline = 'none';
    });

    printClone.querySelectorAll('.ew-editor-text').forEach((el) => {
      el.style.border = 'none';
      el.style.background = 'transparent';
    });

    printClone.querySelectorAll('.ew-editor-image').forEach((el) => {
      el.style.border = 'none';
    });

    await normalizePrintCloneImages(printClone);

    exportWrapper.appendChild(printClone);
    document.body.appendChild(exportWrapper);

    try {
      await waitForNextPaint();

      const printCanvas = await html2canvas(exportWrapper, {
        backgroundColor: '#ffffff',
        useCORS: true,
        logging: false,
        scale: printScale
      });

      if (printCanvas.width === printTargetWidthPx && printCanvas.height === printTargetHeightPx) {
        return printCanvas.toDataURL('image/png');
      }

      const normalizedCanvas = document.createElement('canvas');
      normalizedCanvas.width = printTargetWidthPx;
      normalizedCanvas.height = printTargetHeightPx;

      const normalizedContext = normalizedCanvas.getContext('2d');
      normalizedContext.imageSmoothingEnabled = true;
      normalizedContext.imageSmoothingQuality = 'high';
      normalizedContext.fillStyle = '#ffffff';
      normalizedContext.fillRect(0, 0, printTargetWidthPx, printTargetHeightPx);

      const fitScale = Math.min(
        printTargetWidthPx / printCanvas.width,
        printTargetHeightPx / printCanvas.height
      );

      const drawWidth = printCanvas.width * fitScale;
      const drawHeight = printCanvas.height * fitScale;
      const drawX = (printTargetWidthPx - drawWidth) / 2;
      const drawY = (printTargetHeightPx - drawHeight) / 2;

      normalizedContext.fillStyle = '#ffffff';
      normalizedContext.fillRect(0, 0, printTargetWidthPx, printTargetHeightPx);
      normalizedContext.drawImage(printCanvas, drawX, drawY, drawWidth, drawHeight);

      return normalizedCanvas.toDataURL('image/png');
    } catch (error) {
      console.error('EW printable image generation failed', error);
      return '';
    } finally {
      exportWrapper.remove();
    }
  }

  let syncQueue = Promise.resolve();

  function syncOutputs(options = {}) {
    const { generatePreview = true } = options;

    syncQueue = syncQueue
      .catch(() => {})
      .then(async () => {
        setAddToCartButtonsDisabled(true);

        try {
          await waitForPendingAssets();
          await waitForCanvasImages();
          await waitForNextPaint();

          if (generatePreview) {
            clearPlaceholderTextInContainer(canvas, { markAsRealEmpty: true });
            await waitForNextPaint();
          }

          updateDesignConfig();

          if (!validatePrintImageResolution({ block: generatePreview })) {
            return '';
          }

          const designConfig = getDesignConfigInput()?.value || '';
          const previewImage = generatePreview
            ? await generatePreviewImage()
            : getPreviewInput()?.value || '';

          console.log('[EW syncOutputs start]', {
            hasDesignConfig: !!designConfig,
            hasPreviewImage: !!previewImage,
            formFound: !!getProductForm(),
            existingDesignId: getDesignIdInput()?.value || null
          });

          if (designConfig && previewImage) {
            const designId = await savePersonalizationDesign(designConfig, previewImage, '');
            const designIdInput = getDesignIdInput();
            const designConfigInput = getDesignConfigInput();
            const previewInput = getPreviewInput();

            console.log('[EW savePersonalizationDesign OK]', {
              designId,
              designIdInputFound: !!designIdInput
            });

            if (designIdInput) {
              designIdInput.disabled = false;
              designIdInput.value = designId;
              console.log('[EW designId written]', designIdInput.value);
            }

            if (designConfigInput) {
              designConfigInput.value = '';
              designConfigInput.disabled = true;
            }

            if (previewInput) {
              previewInput.value = '';
              previewInput.disabled = true;
            }
          }

          return previewImage;
          } finally {
            setAddToCartButtonsDisabled(false);
          }
          });

    return syncQueue;
  }


  function getCanvasPointerPosition(event) {
    const rect = canvas.getBoundingClientRect();
    const layoutWidth = canvas.offsetWidth || canvas.clientWidth || 1;
    const layoutHeight = canvas.offsetHeight || canvas.clientHeight || 1;

    const scaleX = rect.width / layoutWidth || 1;
    const scaleY = rect.height / layoutHeight || 1;

    return {
      x: (event.clientX - rect.left) / scaleX,
      y: (event.clientY - rect.top) / scaleY
    };
  }


  function reapplyItemSnapState(item) {
    if (!item || !item.classList || !item.classList.contains('ew-editor-item')) return false;

    const center = getEditableCenter();

    let x = parseFloat(item.getAttribute('data-x')) || 0;
    let y = parseFloat(item.getAttribute('data-y')) || 0;
    let changed = false;

    if (item.dataset.ewSnapX === 'center') {
      x = center.x - (item.offsetWidth / 2);
      changed = true;
    }

    if (item.dataset.ewSnapY === 'center') {
      y = center.y - (item.offsetHeight / 2);
      changed = true;
    }

    if (!changed) return false;

    const clamped = clampItemToEditableArea(item, x, y);
    x = roundEditorValue(clamped.x);
    y = roundEditorValue(clamped.y);

    item.style.transform = `translate(${x}px, ${y}px)`;
    item.setAttribute('data-x', String(x));
    item.setAttribute('data-y', String(y));

    return true;
  }

  function reapplyAllSnapStates() {
    let changed = false;

    canvas.querySelectorAll('.ew-editor-item').forEach((item) => {
      if (reapplyItemSnapState(item)) changed = true;
    });

    if (changed) updateDesignConfig();
  }

  function setupInteract(element) {
    interact(element).draggable({
      ignoreFrom: '.ew-editor-text-content, .ew-delete-handle, .ew-resize-handle',
      listeners: {
        start(event) {
          suppressNextCanvasDeselect = true;

          const target = event.target;
          selectElement(target);

          const pointer = getCanvasPointerPosition(event);
          const x = parseFloat(target.getAttribute('data-x')) || 0;
          const y = parseFloat(target.getAttribute('data-y')) || 0;

          target.dataset.ewDragOffsetX = String(pointer.x - x);
          target.dataset.ewDragOffsetY = String(pointer.y - y);
        },

        move(event) {
          const target = event.target;
          const pointer = getCanvasPointerPosition(event);

          const offsetX = parseFloat(target.dataset.ewDragOffsetX) || 0;
          const offsetY = parseFloat(target.dataset.ewDragOffsetY) || 0;

          let x = pointer.x - offsetX;
          let y = pointer.y - offsetY;

          const clamped = clampItemToEditableArea(target, x, y);
          x = clamped.x;
          y = clamped.y;

          const snapThreshold = isMobileViewport() ? 8 : 4;
          const editableCenter = getEditableCenter();
          const targetCenterX = x + target.offsetWidth / 2;
          const targetCenterY = y + target.offsetHeight / 2;

          let snappedX = false;
          let snappedY = false;

          if (Math.abs(targetCenterX - editableCenter.x) <= snapThreshold) {
            x = editableCenter.x - target.offsetWidth / 2;
            snappedX = true;
          }

          if (Math.abs(targetCenterY - editableCenter.y) <= snapThreshold) {
            y = editableCenter.y - target.offsetHeight / 2;
            snappedY = true;
          }

          const snapped = clampItemToEditableArea(target, x, y);
          x = roundEditorValue(snapped.x);
          y = roundEditorValue(snapped.y);

          if (snappedX) {
            target.dataset.ewSnapX = 'center';
          } else {
            delete target.dataset.ewSnapX;
          }

          if (snappedY) {
            target.dataset.ewSnapY = 'center';
          } else {
            delete target.dataset.ewSnapY;
          }

          target.style.transform = `translate(${x}px, ${y}px)`;
          target.setAttribute('data-x', String(x));
          target.setAttribute('data-y', String(y));

          updateDesignConfig();
        },

        end(event) {
          const target = event.target;

          delete target.dataset.ewDragOffsetX;
          delete target.dataset.ewDragOffsetY;

          reapplyItemSnapState(target);
          selectElement(target);
          updateDesignConfig();

          window.setTimeout(() => {
            suppressNextCanvasDeselect = false;
          }, 0);
        }
      }
    });

    interact(element).resizable({
      edges: { bottom: '.ew-resize-handle', right: '.ew-resize-handle' },
      listeners: {
        move(event) {
          const target = event.target;
          const x = parseFloat(target.getAttribute('data-x')) || 0;
          const y = parseFloat(target.getAttribute('data-y')) || 0;

          const resizeScale = getEditorInteractionScale();
          let width = event.rect.width / resizeScale;
          let height = event.rect.height / resizeScale;

          const editableBounds = getEditableBounds();
          const maxWidth = editableBounds.left + editableBounds.width - x;
          const maxHeight = editableBounds.top + editableBounds.height - y;

          width = Math.max(40, Math.min(width, maxWidth));
          height = Math.max(40, Math.min(height, maxHeight));

          target.style.width = `${width}px`;
          target.style.height = `${height}px`;
          target.style.transform = `translate(${x}px, ${y}px)`;

          updateDesignConfig();
        }
      }
    });

    element.addEventListener('click', () => selectElement(element));

    const textContent = element.querySelector('.ew-editor-text-content');
    if (textContent) {
      textContent.addEventListener('click', (event) => {
        event.stopPropagation();
        selectElement(element);
      });

      textContent.addEventListener('focus', () => {
        applyMobileSafeTextRendering(textContent);

        if (textContent.dataset.ewPlaceholder === 'true') {
          textContent.textContent = '';
          textContent.dataset.ewPlaceholder = 'false';
          syncOutputs({ generatePreview: false });
        }
      });

      textContent.addEventListener('input', () => {
        textContent.dataset.ewPlaceholder = 'false';
        syncOutputs({ generatePreview: false });
      });
    }
  }

  function createTextItem(config = {}) {
    if (textCount >= maxTextCount) return null;

    const defaultTextWidth = isMobileEditorFocusMode() ? 46 : (isMobileViewport() ? 90 : 180);
    const defaultTextHeight = isMobileEditorFocusMode() ? 18 : (isMobileViewport() ? 30 : 60);
    const defaultTextFontSize = isMobileEditorFocusMode() ? 6 : (isMobileViewport() ? 10 : 20);

    const wrapper = document.createElement('div');
    wrapper.className = 'ew-editor-item ew-editor-text';
    wrapper.style.width = `${config.width || defaultTextWidth}px`;
    wrapper.style.height = `${config.height || defaultTextHeight}px`;
    wrapper.style.whiteSpace = 'normal';
    wrapper.style.color = '#111';
    wrapper.style.display = 'flex';
    wrapper.style.alignItems = 'stretch';

    const content = document.createElement('div');
    content.className = 'ew-editor-text-content';
    content.contentEditable = true;
    const hasTextProperty = Object.prototype.hasOwnProperty.call(config, 'text');
    const textValue = hasTextProperty ? String(config.text || '') : '';
    const shouldUseDefaultPlaceholder = !hasTextProperty && config.useDefaultPlaceholder !== false;

    content.textContent = shouldUseDefaultPlaceholder ? 'Dein Text' : textValue;
    content.dataset.ewPlaceholder = shouldUseDefaultPlaceholder ? 'true' : 'false';
    content.style.width = '100%';
    content.style.height = '100%';
    content.style.outline = 'none';
    content.style.whiteSpace = 'pre-wrap';
    content.style.wordBreak = 'break-word';
    content.style.overflow = 'hidden';
    content.style.fontFamily = config.fontFamily || 'Arial, sans-serif';
    setEditorTextFontSize(content, config.fontSize || defaultTextFontSize);
    content.style.color = config.color || '#000000';
    content.style.textAlign = config.textAlign || 'left';
    content.style.fontWeight = config.fontWeight || '400';
    content.style.textDecorationLine = config.textDecorationLine || 'none';
    content.style.lineHeight = '1.2';

    const defaultPosition = getDefaultItemPosition(config.width || defaultTextWidth, config.height || defaultTextHeight);
    const x = typeof config.x === 'number' ? config.x : defaultPosition.x;
    const y = typeof config.y === 'number' ? config.y : defaultPosition.y;

    wrapper.setAttribute('data-x', String(x));
    wrapper.setAttribute('data-y', String(y));
    wrapper.style.transform = `translate(${x}px, ${y}px)`;

    const layer = Number.isFinite(Number(config.layer)) ? Number(config.layer) : null;
    if (layer !== null) {
      wrapper.style.zIndex = String(layer);
      wrapper.setAttribute('data-layer', String(layer));
      currentLayerIndex = Math.max(currentLayerIndex, layer);
    } else {
      bringElementToFront(wrapper);
    }

    wrapper.appendChild(content);
    createResizeHandle(wrapper);
    canvas.appendChild(wrapper);
    setupInteract(wrapper);

    if (config.autoSelect !== false) {
      selectElement(wrapper);
    }

    textCount += 1;
    addTextButton.disabled = textCount >= maxTextCount;
    return wrapper;
  }


  const EW_PRINT_DPI = 200;
  const EW_PRINT_FORMAT_WIDTH_MM = 118;
  const EW_PRINT_FORMAT_HEIGHT_MM = 171;
  const EW_PRINT_CONTENT_SCALE = Math.min(
    EW_PRINT_FORMAT_WIDTH_MM / EW_CARD_SPEC.editableWidthMm,
    EW_PRINT_FORMAT_HEIGHT_MM / EW_CARD_SPEC.editableHeightMm
  );

  function getResolutionMessageElement() {
    let message = root.querySelector('#ew-editor-resolution-message');

    if (!message) {
      message = document.createElement('div');
      message.id = 'ew-editor-resolution-message';
      message.className = 'ew-editor-resolution-message';
      message.setAttribute('role', 'alert');

      const toolbar = root.querySelector('.ew-editor-text-toolbar');
      if (toolbar && toolbar.parentNode) {
        toolbar.parentNode.insertBefore(message, toolbar.nextSibling);
      } else {
        root.appendChild(message);
      }
    }

    return message;
  }

  function setImageResolutionMessage(text, type = 'warning') {
    const message = getResolutionMessageElement();

    if (!text) {
      message.textContent = '';
      message.classList.remove('ew-visible', 'ew-error');
      return;
    }

    message.textContent = text;
    message.classList.add('ew-visible');
    message.classList.toggle('ew-error', type === 'error');
  }

  function getPrintRequirementForEditorSize(width, height) {
    const bounds = getEditableBounds();

    if (!bounds.width || !bounds.height) {
      return { widthPx: 0, heightPx: 0 };
    }

    const widthMm = (width / bounds.width) * EW_CARD_SPEC.editableWidthMm * EW_PRINT_CONTENT_SCALE;
    const heightMm = (height / bounds.height) * EW_CARD_SPEC.editableHeightMm * EW_PRINT_CONTENT_SCALE;

    return {
      widthPx: Math.ceil((widthMm / 25.4) * EW_PRINT_DPI),
      heightPx: Math.ceil((heightMm / 25.4) * EW_PRINT_DPI)
    };
  }

  function getDefaultImageSizeForCurrentView() {
    return {
      width: isMobileEditorFocusMode() ? 42 : (isMobileViewport() ? 64 : 140),
      height: isMobileEditorFocusMode() ? 42 : (isMobileViewport() ? 64 : 140)
    };
  }

  function imageMeetsPrintRequirement(naturalWidth, naturalHeight, editorWidth, editorHeight) {
    const required = getPrintRequirementForEditorSize(editorWidth, editorHeight);

    return {
      ok: naturalWidth >= required.widthPx && naturalHeight >= required.heightPx,
      required
    };
  }

  function validateUploadImageResolution(naturalWidth, naturalHeight) {
    const defaultSize = getDefaultImageSizeForCurrentView();
    const result = imageMeetsPrintRequirement(
      naturalWidth,
      naturalHeight,
      defaultSize.width,
      defaultSize.height
    );

    if (!result.ok) {
      setImageResolutionMessage(
        `Dieses Bild ist für den Druck zu klein. Bitte lade eine Datei mit höherer Auflösung hoch.`,
        'error'
      );
      return false;
    }

    setImageResolutionMessage('');
    return true;
  }

  function validatePrintImageResolution(options = {}) {
    const { block = false } = options;
    const issues = [];

    canvas.querySelectorAll('.ew-editor-image').forEach((item) => {
      const img = item.querySelector('img');
      if (!img) return;

      const naturalWidth = Number(item.dataset.ewOriginalWidth || img.naturalWidth || 0);
      const naturalHeight = Number(item.dataset.ewOriginalHeight || img.naturalHeight || 0);

      if (!naturalWidth || !naturalHeight) return;

      const result = imageMeetsPrintRequirement(
        naturalWidth,
        naturalHeight,
        item.offsetWidth,
        item.offsetHeight
      );

      if (!result.ok) {
        issues.push({
          naturalWidth,
          naturalHeight,
          requiredWidth: result.required.widthPx,
          requiredHeight: result.required.heightPx
        });
      }
    });

    if (!issues.length) {
      setImageResolutionMessage('');
      return true;
    }

    const first = issues[0];
    setImageResolutionMessage(
      `Die aktuelle Bildauflösung ist für den Druck zu niedrig. Bitte ziehe das Bild kleiner oder lade eine Datei mit höherer Auflösung hoch.`,
      'error'
    );

    return !block;
  }

  function createImageItem(src, config = {}) {
    if (!src || imageCount >= 3) return null;

    const defaultImageWidth = isMobileEditorFocusMode() ? 42 : (isMobileViewport() ? 64 : 140);
    const defaultImageHeight = isMobileEditorFocusMode() ? 42 : (isMobileViewport() ? 64 : 140);

    const wrapper = document.createElement('div');
    wrapper.className = 'ew-editor-item ew-editor-image';

    const imageId = config.imageId || `temp-${Date.now()}`;
    wrapper.setAttribute('data-image-id', imageId);

    if (config.originalWidth) {
      wrapper.dataset.ewOriginalWidth = String(config.originalWidth);
    }

    if (config.originalHeight) {
      wrapper.dataset.ewOriginalHeight = String(config.originalHeight);
    }
    wrapper.style.width = `${config.width || defaultImageWidth}px`;
    wrapper.style.height = `${config.height || defaultImageHeight}px`;

    const defaultPosition = getDefaultItemPosition(config.width || defaultImageWidth, config.height || defaultImageHeight);
    const x = typeof config.x === 'number' ? config.x : defaultPosition.x;
    const y = typeof config.y === 'number' ? config.y : defaultPosition.y;

    wrapper.setAttribute('data-x', String(x));
    wrapper.setAttribute('data-y', String(y));
    wrapper.style.transform = `translate(${x}px, ${y}px)`;

    const img = document.createElement('img');
    img.src = src;
    img.draggable = false;
    img.style.pointerEvents = 'none';
    img.style.userSelect = 'none';
    img.style.webkitUserSelect = 'none';
    saveImageSource(imageId, src);
    img.style.width = '100%';
    img.style.height = '100%';
    img.style.display = 'block';
    img.style.objectFit = 'cover';
    img.draggable = false;

    wrapper.appendChild(img);
    bringElementToFront(wrapper);

    const layer = Number.isFinite(Number(config.layer)) ? Number(config.layer) : null;
    if (layer !== null) {
      wrapper.style.zIndex = String(layer);
      wrapper.setAttribute('data-layer', String(layer));
      currentLayerIndex = Math.max(currentLayerIndex, layer);
    }

    createResizeHandle(wrapper);
    canvas.appendChild(wrapper);
    setupInteract(wrapper);

    if (config.autoSelect !== false) {
      selectElement(wrapper);
    }

    imageCount += 1;
    return wrapper;
  }

  function resetEditorCanvas() {
    canvas.querySelectorAll('.ew-editor-item').forEach((item) => item.remove());
    textCount = 0;
    imageCount = 0;
    addTextButton.disabled = false;
    selectedElement = null;
  }

  async function restoreDesignFromConfig(configValue) {
    let items = [];

    try {
      items = typeof configValue === 'string' ? JSON.parse(configValue || '[]') : (configValue || []);
    } catch (error) {
      console.error('EW restore failed: invalid design config', error);
      items = [];
    }

    resetEditorCanvas();

    const pendingLoads = [];

    items.forEach((item) => {
      if (!item || !item.type) return;

      if (item.type === 'text') {
        createTextItem({
          text: item.text || '',
          fontFamily: item.fontFamily || 'Arial, sans-serif',
          fontSize: item.fontSize || 20,
          color: item.color || '#000000',
          textAlign: item.textAlign || 'left',
          x: Number(item.x) || 0,
          y: Number(item.y) || 0,
          width: Number(item.width) || 180,
          height: Number(item.height) || 60,
          layer: Number(item.layer) || 1,
          fontFamily: item.fontFamily || 'Arial, sans-serif',
          fontSize: Number(item.fontSize) || 20,
          color: item.color || '#000000',
          textAlign: item.textAlign || 'left',
          fontWeight: item.fontWeight || '400',
          textDecorationLine: item.textDecorationLine || 'none',
          autoSelect: false
        });
      }

      if (item.type === 'image') {
        const restoredImageSrc =
          getImageSource(item.imageId || '') ||
          item.previewSrc ||
          item.src ||
          item.imageSrc ||
          '';

        if (!restoredImageSrc) return;

        const imageItem = createImageItem(restoredImageSrc, {
          imageId: item.imageId || '',
          x: Number(item.x) || 0,
          y: Number(item.y) || 0,
          width: Number(item.width) || 140,
          height: Number(item.height) || 140,
          layer: Number(item.layer) || 1,
          originalWidth: Number(item.originalWidth) || 0,
          originalHeight: Number(item.originalHeight) || 0,
          fontFamily: item.fontFamily || 'Arial, sans-serif',
          fontSize: Number(item.fontSize) || 20,
          color: item.color || '#000000',
          textAlign: item.textAlign || 'left',
          autoSelect: false
        });

        const img = imageItem ? imageItem.querySelector('img') : null;

        if (img && (!img.complete || img.naturalWidth === 0)) {
          pendingLoads.push(
            new Promise((resolve) => {
              const done = () => resolve();
              img.addEventListener('load', done, { once: true });
              img.addEventListener('error', done, { once: true });
            })
          );
        }
      }
    });

    if (pendingLoads.length) {
      await Promise.all(pendingLoads);
    }

    await waitForNextPaint();
    await syncOutputs({ generatePreview: false });
    return true;
  }


  if (focusToggleButton && canvasViewport) {
    let focusTogglePointerHandled = false;

    function activateFocusToggle(event) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();

        if (typeof event.stopImmediatePropagation === 'function') {
          event.stopImmediatePropagation();
        }
      }

      const willEnable = !canvasViewport.classList.contains('ew-focus-right');

      if (!willEnable) {
        blurActiveEditorTextContent();
      }

      suppressNextCanvasDeselect = true;
      setEditorFocusMode(willEnable);

      window.setTimeout(() => {
        suppressNextCanvasDeselect = false;
      }, 300);
    }

    focusToggleButton.addEventListener('pointerdown', (event) => {
      if (!isMobileViewport()) return;

      focusTogglePointerHandled = true;
      activateFocusToggle(event);

      window.setTimeout(() => {
        focusTogglePointerHandled = false;
      }, 500);
    }, { capture: true });

    if (!window.PointerEvent) {
      focusToggleButton.addEventListener('touchstart', (event) => {
        if (!isMobileViewport()) return;

        focusTogglePointerHandled = true;
        activateFocusToggle(event);

        window.setTimeout(() => {
          focusTogglePointerHandled = false;
        }, 500);
      }, { passive: false, capture: true });
    }

    focusToggleButton.addEventListener('click', (event) => {
      if (focusTogglePointerHandled) {
        event.preventDefault();
        event.stopPropagation();
        return;
      }

      activateFocusToggle(event);
    });

    window.addEventListener('resize', () => {
      if (!isMobileViewport()) {
        setEditorFocusMode(false);
      }
    });
  }

  root.addEventListener('touchstart', prepareMobileTextFieldBeforeFocus, {
    passive: true,
    capture: true
  });

  root.addEventListener('pointerdown', prepareMobileTextFieldBeforeFocus, {
    passive: true,
    capture: true
  });

  window.addEventListener('resize', () => {
    refreshMobileSafeTextRendering();
    updateEditorFocusTransform();

    if (isMobileEditorFocusMode()) {
      updateFloatingFocusTogglePosition();
    } else {
      restoreFocusToggleFromFloatingLayer();
    }
  });

  addTextButton.addEventListener('click', () => {
    const item = createTextItem();
    if (item) syncOutputs({ generatePreview: false });
  });

  if (fontFamilySelect) {
    fontFamilySelect.addEventListener('change', () => {
      applyTextStyle({ fontFamily: fontFamilySelect.value });
    });
  }

  if (fontSizeInput) {
    fontSizeInput.addEventListener('change', () => {
      applyTextStyle({ fontSize: parseInt(fontSizeInput.value || '20', 10) || 20 });
    });
  }

  function closeColorMenu() {
    if (!colorMenu || !colorToggleButton) return;
    colorMenu.hidden = true;
    colorToggleButton.setAttribute('aria-expanded', 'false');
  }

  if (colorToggleButton && colorMenu) {
    colorToggleButton.addEventListener('click', (event) => {
      event.stopPropagation();
      const willOpen = colorMenu.hidden;
      colorMenu.hidden = !willOpen;
      colorToggleButton.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
    });
  }

  colorSwatches.forEach((button) => {
    button.style.backgroundColor = button.dataset.color || '#000000';

    button.addEventListener('click', () => {
      const color = button.dataset.color || '#000000';
      if (fontColorInput) fontColorInput.value = color;
      if (colorPreview) colorPreview.style.backgroundColor = color;
      applyTextStyle({ color });
      closeColorMenu();
    });
  });

  document.addEventListener('click', (event) => {
    if (!colorMenu || colorMenu.hidden) return;
    if (event.target.closest('#ew-color-menu') || event.target.closest('#ew-color-menu-toggle')) return;
    closeColorMenu();
  });

  if (fontColorInput) {
    fontColorInput.addEventListener('change', () => {
      const color = /^#[0-9a-fA-F]{6}$/.test(fontColorInput.value)
        ? fontColorInput.value
        : '#000000';

      fontColorInput.value = color;
      if (colorPreview) colorPreview.style.backgroundColor = color;
      applyTextStyle({ color });
      closeColorMenu();
    });
  }

  if (boldButton) {
    boldButton.addEventListener('click', () => {
      const isActive = boldButton.classList.contains('ew-active');
      applyTextStyle({ fontWeight: isActive ? '400' : '700' });
    });
  }

  if (underlineButton) {
    underlineButton.addEventListener('click', () => {
      const isActive = underlineButton.classList.contains('ew-active');
      applyTextStyle({ textDecorationLine: isActive ? 'none' : 'underline' });
    });
  }

  alignButtons.forEach((button) => {
    button.addEventListener('click', () => {
      applyTextStyle({ textAlign: button.dataset.align || 'left' });
    });
  });

  if (gridToggleButton) {
    gridToggleButton.addEventListener('click', () => {
      const hideGrid = !canvas.classList.contains('ew-grid-hidden');
      canvas.classList.toggle('ew-grid-hidden', hideGrid);
      gridToggleButton.classList.toggle('ew-active', !hideGrid);
      gridToggleButton.setAttribute('aria-pressed', hideGrid ? 'false' : 'true');
    });
  }

  imageUpload.addEventListener('change', (event) => {
    const file = event.target.files?.[0];
    if (!file || imageCount >= 3) return;

    markAssetPending();

    const reader = new FileReader();

    reader.onload = (e) => {
      const src = e.target.result;
      const probe = new Image();

      probe.onload = () => {
        const naturalWidth = probe.naturalWidth || 0;
        const naturalHeight = probe.naturalHeight || 0;

        if (!validateUploadImageResolution(naturalWidth, naturalHeight)) {
          markAssetReady();
          event.target.value = '';
          return;
        }

        const item = createImageItem(src, {
          originalWidth: naturalWidth,
          originalHeight: naturalHeight
        });

        if (!item) {
          markAssetReady();
          return;
        }

        const img = item.querySelector('img');

        const finalize = () => {
          waitForNextPaint().then(() => {
            markAssetReady();
            validatePrintImageResolution({ block: false });
            syncOutputs({ generatePreview: false });
          });
        };

        if (img && (!img.complete || img.naturalWidth === 0)) {
          img.addEventListener('load', finalize, { once: true });
          img.addEventListener('error', finalize, { once: true });
        } else {
          finalize();
        }
      };

      probe.onerror = () => {
        markAssetReady();
        setImageResolutionMessage('Dieses Bild konnte nicht geprüft werden. Bitte ein anderes Bild hochladen.', 'error');
      };

      probe.src = src;
    };

    reader.onerror = () => {
      markAssetReady();
      setImageResolutionMessage('Dieses Bild konnte nicht gelesen werden. Bitte erneut versuchen.', 'error');
    };

    reader.readAsDataURL(file);
    event.target.value = '';
  });

  canvas.addEventListener('pointerup', () => validatePrintImageResolution({ block: false }));

  canvas.addEventListener('click', (e) => {
    if (suppressNextCanvasDeselect) {
      e.preventDefault();
      e.stopPropagation();

      window.setTimeout(() => {
        suppressNextCanvasDeselect = false;
      }, 0);

      return;
    }

    if (e.target === canvas) {
      selectElement(null);
    }
  });

  root.ewRestoreDesign = restoreDesignFromConfig;
  updateCenterGuides();
  root.ewSyncOutputs = syncOutputs;
  root.ewGeneratePrintableImage = generatePrintableImage;
  root.ewGetPersonalizationPayload = async () => {
    await syncOutputs();

    return {
      designId: getDesignIdInput()?.value || '',
      designConfig: '',
      previewImage: ''
    };
  };

  window.ewRestoreEditorFromConfig = async function(configValue) {
    const editorRoot =
      document.querySelector('#ew-card-editor-root[data-ew-editor-initialized="true"]') ||
      document.querySelector('#ew-card-editor-root');

    if (!editorRoot || typeof editorRoot.ewRestoreDesign !== 'function') {
      console.warn('EW Editor: keine aktive Restore-Funktion gefunden');
      return false;
    }

    await editorRoot.ewRestoreDesign(configValue);
    return true;
  };


  canvas.querySelectorAll('.ew-debug-bounds, .ew-debug-center-x, .ew-debug-center-y, .ew-debug-center-dot').forEach((el) => el.remove());

  updateDesignConfig();

  const previewInput = getPreviewInput();
  if (previewInput && !previewInput.value) {
    previewInput.value = '';
  }

  setAddToCartButtonsDisabled(false);
}

function initAllEwCardEditors(scope = document) {
  scope.querySelectorAll('#ew-card-editor-root').forEach((root) => {
    initEwCardEditor(root);
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initAllEwCardEditors(document);
});

const ewEditorObserver = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    mutation.addedNodes.forEach((node) => {
      if (!(node instanceof Element)) return;

      if (node.matches && node.matches('#ew-card-editor-root')) {
        initEwCardEditor(node);
      } else if (node.querySelectorAll) {
        initAllEwCardEditors(node);
      }
    });
  });
});

ewEditorObserver.observe(document.body, {
  childList: true,
  subtree: true
});


/* EW FINAL COPY: rename personalization title */
(function () {
  function renamePersonalizationTitle() {
    document.querySelectorAll('[id^="ewPersonalizationCanvas-"]').forEach((panel) => {
      panel.querySelectorAll('*').forEach((el) => {
        if (el.children.length > 0) return;

        const current = el.textContent.trim().replace(/\s+/g, ' ');

        if (current === 'PERSONALISIERUNG') {
          el.textContent = 'PERSONALISIERUNG INNENSEITE';
        }
      });
    });
  }

  renamePersonalizationTitle();

  document.addEventListener('DOMContentLoaded', renamePersonalizationTitle);
  document.addEventListener('shown.bs.offcanvas', renamePersonalizationTitle);

  const observer = new MutationObserver(renamePersonalizationTitle);
  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();


/* EW LOADING: stable CSS/SVG snail for personalization apply button */
(function () {
  if (window.ewApplyPersonalizationStableSnailInstalled) return;
  window.ewApplyPersonalizationStableSnailInstalled = true;

  function ensureLoadingStyles() {
    if (document.querySelector('#ew-apply-stable-snail-styles')) return;

    const style = document.createElement('style');
    style.id = 'ew-apply-stable-snail-styles';
    style.textContent = `
      button[id^="ew-apply-personalization-"].ew-apply-loading,
      .ew-apply-personalization.ew-apply-loading {
        pointer-events: none !important;
        opacity: 0.96 !important;
      }

      .ew-apply-loading-inner {
        display: inline-flex !important;
        align-items: center !important;
        justify-content: center !important;
        gap: 10px !important;
        width: 100% !important;
      }

      .ew-apply-snail {
        width: 42px !important;
        height: 26px !important;
        overflow: visible !important;
        animation: ew-snail-dash 0.8s ease-in-out infinite alternate;
      }

      .ew-apply-snail .ew-snail-body {
        animation: ew-snail-wiggle 0.5s ease-in-out infinite alternate;
        transform-origin: center;
      }

      .ew-apply-snail .ew-snail-speed {
        animation: ew-snail-speed 0.7s linear infinite;
      }

      @keyframes ew-snail-dash {
        from { transform: translateX(-2px); }
        to { transform: translateX(4px); }
      }

      @keyframes ew-snail-wiggle {
        from { transform: rotate(-1deg); }
        to { transform: rotate(2deg); }
      }

      @keyframes ew-snail-speed {
        from { opacity: 0.15; transform: translateX(0); }
        to { opacity: 0.75; transform: translateX(-5px); }
      }

      .ew-apply-loading-inner span {
        white-space: nowrap !important;
      }

      @media (max-width: 767px) {
        .ew-apply-snail {
          width: 36px !important;
          height: 23px !important;
        }

        .ew-apply-loading-inner {
          gap: 8px !important;
        }
      }
    `;

    document.head.appendChild(style);
  }

  function getSnailSvg() {
    return `
      <svg class="ew-apply-snail" viewBox="0 0 84 52" aria-hidden="true" focusable="false">
        <g class="ew-snail-speed" fill="none" stroke="#1f1966" stroke-width="3" stroke-linecap="round" opacity=".45">
          <path d="M8 23H22"/>
          <path d="M2 32H20"/>
          <path d="M12 41H28"/>
        </g>

        <g class="ew-snail-body">
          <path d="M28 39c8 7 34 7 43-2 7-7 4-18-8-18H47c-8 0-15 6-19 20Z" fill="#f59bea" stroke="#1f1966" stroke-width="3" stroke-linejoin="round"/>
          <circle cx="42" cy="23" r="15" fill="#a9b7ff" stroke="#1f1966" stroke-width="3"/>
          <path d="M42 23c7-1 9 8 2 10-7 2-13-7-6-14" fill="none" stroke="#1f1966" stroke-width="3" stroke-linecap="round"/>
          <path d="M62 20L70 8M68 20L79 9" fill="none" stroke="#1f1966" stroke-width="3" stroke-linecap="round"/>
          <circle cx="71" cy="7" r="4" fill="#fff" stroke="#1f1966" stroke-width="3"/>
          <circle cx="80" cy="8" r="4" fill="#fff" stroke="#1f1966" stroke-width="3"/>
          <path d="M65 31c3 3 7 3 10 0" fill="none" stroke="#1f1966" stroke-width="3" stroke-linecap="round"/>
        </g>
      </svg>
    `;
  }

  function getLoadingHtml() {
    return `
      <span class="ew-apply-loading-inner">
        ${getSnailSvg()}
        <span>Personalisierung wird übernommen…</span>
      </span>
    `;
  }

  function applyLoadingHtml(button) {
    if (!button || !button.classList.contains('ew-apply-loading')) return;

    if (!button.querySelector('.ew-apply-loading-inner')) {
      button.innerHTML = getLoadingHtml();
    }
  }

  function setApplyButtonLoading(button, loading) {
    if (!button) return;

    ensureLoadingStyles();

    if (loading) {
      if (!button.dataset.ewOriginalHtml) {
        button.dataset.ewOriginalHtml = button.innerHTML;
      }

      button.classList.add('ew-apply-loading');
      button.setAttribute('aria-busy', 'true');
      button.innerHTML = getLoadingHtml();

      if (!button.ewLoadingObserver) {
        button.ewLoadingObserver = new MutationObserver(() => {
          window.requestAnimationFrame(() => applyLoadingHtml(button));
        });

        button.ewLoadingObserver.observe(button, {
          childList: true,
          subtree: true,
          characterData: true
        });
      }

      return;
    }

    button.classList.remove('ew-apply-loading');
    button.removeAttribute('aria-busy');

    if (button.ewLoadingObserver) {
      button.ewLoadingObserver.disconnect();
      button.ewLoadingObserver = null;
    }

    if (button.dataset.ewOriginalHtml) {
      button.innerHTML = button.dataset.ewOriginalHtml;
      delete button.dataset.ewOriginalHtml;
    }
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest(
      'button[id^="ew-apply-personalization-"], .ew-apply-personalization'
    );

    if (!button) return;

    setApplyButtonLoading(button, true);
  }, true);

  document.addEventListener('hidden.bs.offcanvas', () => {
    document
      .querySelectorAll('button[id^="ew-apply-personalization-"].ew-apply-loading, .ew-apply-personalization.ew-apply-loading')
      .forEach((button) => setApplyButtonLoading(button, false));
  });
})();

/* EW OFFCANVAS: desktop-only drawer layer fix */
(function () {
  if (window.ewPersonalizationDrawerLayerFixInstalled) return;
  window.ewPersonalizationDrawerLayerFixInstalled = true;

  const PERSONALIZATION_SELECTOR = '[id^="ewPersonalizationCanvas-"].offcanvas';
  const desktopQuery = window.matchMedia('(min-width: 768px)');

  function isDesktopLayerFixEnabled() {
    return desktopQuery.matches;
  }

  function isPersonalizationPanel(element) {
    return element instanceof Element && element.matches(PERSONALIZATION_SELECTOR);
  }

  function getOpenPersonalizationPanel() {
    return document.querySelector(
      `${PERSONALIZATION_SELECTOR}.show, ${PERSONALIZATION_SELECTOR}.showing`
    );
  }

  function setPersonalizationOpenState(open) {
    const shouldApply = isDesktopLayerFixEnabled() && open;

    document.documentElement.classList.toggle('ew-personalization-open', shouldApply);
    document.body.classList.toggle('ew-personalization-open', shouldApply);
  }

  function refreshPersonalizationOpenState() {
    setPersonalizationOpenState(!!getOpenPersonalizationPanel());
  }

  function rememberOriginalPosition(panel) {
    if (!isPersonalizationPanel(panel)) return;
    if (panel.ewOriginalPlaceholder) return;
    if (!panel.parentNode) return;

    const placeholder = document.createComment('EW personalization original position');
    panel.parentNode.insertBefore(placeholder, panel);
    panel.ewOriginalPlaceholder = placeholder;
  }

  function movePanelToBody(panel) {
    if (!isDesktopLayerFixEnabled()) return;
    if (!isPersonalizationPanel(panel)) return;

    rememberOriginalPosition(panel);

    if (panel.parentElement !== document.body) {
      document.body.appendChild(panel);
    }
  }

  function restorePanelPosition(panel) {
    if (!isPersonalizationPanel(panel)) return;

    const placeholder = panel.ewOriginalPlaceholder;

    if (
      placeholder &&
      placeholder.parentNode &&
      panel.parentElement === document.body
    ) {
      placeholder.parentNode.insertBefore(panel, placeholder.nextSibling);
    }
  }

  function moveAllPersonalizationPanelsToBody() {
    if (!isDesktopLayerFixEnabled()) return;

    document
      .querySelectorAll(PERSONALIZATION_SELECTOR)
      .forEach(movePanelToBody);
  }

  function restoreAllPersonalizationPanels() {
    document
      .querySelectorAll(PERSONALIZATION_SELECTOR)
      .forEach(restorePanelPosition);
  }

  function handleViewportModeChange() {
    if (isDesktopLayerFixEnabled()) {
      moveAllPersonalizationPanelsToBody();
      refreshPersonalizationOpenState();
      return;
    }

    // Mobile: keine Layer-/Scroll-Sperre, kein DOM-Move, keine Touch-Blockade.
    setPersonalizationOpenState(false);
    restoreAllPersonalizationPanels();
  }

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest(
      '[data-bs-toggle="offcanvas"][data-bs-target^="#ewPersonalizationCanvas-"],' +
      '[data-bs-toggle="offcanvas"][href^="#ewPersonalizationCanvas-"],' +
      '[data-bs-target^="#ewPersonalizationCanvas-"],' +
      '[href^="#ewPersonalizationCanvas-"]'
    );

    if (!trigger) return;

    if (!isDesktopLayerFixEnabled()) {
      setPersonalizationOpenState(false);
      restoreAllPersonalizationPanels();
      return;
    }

    moveAllPersonalizationPanelsToBody();
  }, true);

  document.addEventListener('show.bs.offcanvas', (event) => {
    if (!isPersonalizationPanel(event.target)) return;

    if (!isDesktopLayerFixEnabled()) {
      setPersonalizationOpenState(false);
      restorePanelPosition(event.target);
      return;
    }

    movePanelToBody(event.target);
    setPersonalizationOpenState(true);
  }, true);

  document.addEventListener('shown.bs.offcanvas', (event) => {
    if (!isPersonalizationPanel(event.target)) return;

    if (!isDesktopLayerFixEnabled()) {
      setPersonalizationOpenState(false);
      return;
    }

    movePanelToBody(event.target);
    setPersonalizationOpenState(true);

    const body = event.target.querySelector('.offcanvas-body');
    if (body) {
      body.style.touchAction = 'pan-y';
      body.style.overflowY = 'auto';
      body.style.webkitOverflowScrolling = 'touch';
    }
  }, true);

  document.addEventListener('hidden.bs.offcanvas', (event) => {
    if (!isPersonalizationPanel(event.target)) return;

    window.requestAnimationFrame(refreshPersonalizationOpenState);
  }, true);

  /*
    Nur Desktop:
    Hintergrund-Scroll blockieren, aber Scrollen im Personalisierungs-Offcanvas erlauben.
    Mobile wird bewusst ausgeschlossen, damit Zoom-/Touch-Interaktion im Editor nicht blockiert.
  */
  document.addEventListener('wheel', (event) => {
    if (!isDesktopLayerFixEnabled()) return;

    const panel = getOpenPersonalizationPanel();
    if (!panel) return;

    if (!panel.contains(event.target)) {
      event.preventDefault();
    }
  }, { passive: false, capture: true });

  document.addEventListener('touchmove', (event) => {
    if (!isDesktopLayerFixEnabled()) return;

    const panel = getOpenPersonalizationPanel();
    if (!panel) return;

    if (!panel.contains(event.target)) {
      event.preventDefault();
    }
  }, { passive: false, capture: true });

  if (desktopQuery.addEventListener) {
    desktopQuery.addEventListener('change', handleViewportModeChange);
  } else if (desktopQuery.addListener) {
    desktopQuery.addListener(handleViewportModeChange);
  }

  document.addEventListener('DOMContentLoaded', handleViewportModeChange);

  const observer = new MutationObserver(() => {
    if (isDesktopLayerFixEnabled()) {
      moveAllPersonalizationPanelsToBody();
    }

    refreshPersonalizationOpenState();
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  handleViewportModeChange();
})();
